import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCAutomationsLog(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 503.24 354.61">
            <defs>
                <linearGradient
                    id="linear-gradient-automations-log"
                    x1="-0.001"
                    y1="0.5"
                    x2="0.999"
                    y2="0.5"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stopColor="#4042e2" />
                    <stop offset="1" stopColor="#4f52ff" />
                </linearGradient>
                <linearGradient
                    id="linear-gradient-automations-log-2"
                    x1="-0.021"
                    y1="0.503"
                    x2="0.979"
                    y2="0.503"
                    xlinkHref="#linear-gradient-automations-log"
                />
            </defs>
            <g id="Automations_Log" transform="translate(-4.38 -68.59)">
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="251.62"
                    cy="43.62"
                    rx="251.62"
                    ry="43.62"
                    transform="translate(4.38 335.96)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M332.76,376.27H217V272a8.13,8.13,0,0,1,8.12-8.12h99.49a8.13,8.13,0,0,1,8.12,8.12Z"
                    fill="#717272"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M319.74,376.27H204V272a8.13,8.13,0,0,1,8.12-8.12h99.49a8.13,8.13,0,0,1,8.12,8.12Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M381.89,223h13.44a40.42,40.42,0,0,1,40.42,40.42V370.57H341.47V263.39A40.42,40.42,0,0,1,381.89,223Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M369.72,223h13.44a40.42,40.42,0,0,1,40.42,40.42V370.57H329.3V263.39A40.42,40.42,0,0,1,369.72,223Z"
                    fill="#717272"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M157.34,209.6h9.3a39.83,39.83,0,0,1,39.83,39.83v127h-89v-127a39.83,39.83,0,0,1,39.87-39.83Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M145.85,209.6h9.3A39.83,39.83,0,0,1,195,249.43v127H106v-127a39.83,39.83,0,0,1,39.83-39.83Z"
                    fill="#717272"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M137.44,234.17c13.35,3.08,22.76-.18,31.85-9.06a2.15,2.15,0,0,0,.52-2.22l-.16-.45a2.12,2.12,0,0,0-3.32-.94c-8.21,6.61-14.63,10.81-28.07,8.53a2.11,2.11,0,0,0-2.41,2.55h0a2.12,2.12,0,0,0,1.59,1.59Z"
                    fill="#fff"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M141.17,238.78l-9-7a.47.47,0,0,1,.1-.79l10.06-4.39a.53.53,0,0,1,.74.54,23.57,23.57,0,0,0-1.19,11.37.45.45,0,0,1-.71.27Z"
                    fill="#fff"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M200.74,170c5.76,9.4,12.94,13,23.15,13.15a1.7,1.7,0,0,0,1.57-1l.16-.34a1.69,1.69,0,0,0-1.32-2.43c-8.43-1-14.45-2.3-20.73-11.29a1.69,1.69,0,0,0-2.81.05h0a1.69,1.69,0,0,0-.02,1.86Z"
                    fill="#fff"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M200.2,174.77l-1-9.11a.38.38,0,0,1,.51-.39l8.19,3.29a.43.43,0,0,1,.11.73,19,19,0,0,0-7.2,5.73.37.37,0,0,1-.61-.25Z"
                    fill="#fff"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M355.64,227.63c5.17,9.43,12,13.24,21.94,13.91a1.66,1.66,0,0,0,1.56-.85l.18-.33a1.65,1.65,0,0,0-1.17-2.43c-8.17-1.36-14-2.92-19.66-12a1.65,1.65,0,0,0-2.75-.08h0a1.65,1.65,0,0,0-.1,1.78Z"
                    fill="#fff"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M354.89,232.23l-.56-8.93a.36.36,0,0,1,.51-.35l7.82,3.59a.41.41,0,0,1,.07.71,18.54,18.54,0,0,0-7.27,5.25.36.36,0,0,1-.57-.27Z"
                    fill="#fff"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M146.4,376.2H56.31V316.33a8.11,8.11,0,0,1,8.12-8.11h73.85a8.12,8.12,0,0,1,8.12,8.11Z"
                    fill="#717272"
                />
                <path
                    id="Path_14"
                    data-name="Path 14"
                    d="M132.9,376.2H42.82V316.33a8.11,8.11,0,0,1,8.11-8.11h73.86a8.11,8.11,0,0,1,8.11,8.11Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M462.34,375.82h-90.7V294a8.13,8.13,0,0,1,8.12-8.12h74.46a8.13,8.13,0,0,1,8.12,8.12Z"
                    fill="#717272"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M452.14,375.82h-90.7V294a8.12,8.12,0,0,1,8.12-8.12H444a8.13,8.13,0,0,1,8.12,8.12Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M367.4,140.1l50.39,2.18a5.23,5.23,0,0,1,5,5.19l.56,73.22a3.86,3.86,0,0,1-4,3.88l-57.81-1.45a3.65,3.65,0,0,1-3.56-3.81l3.18-73.54a5.94,5.94,0,0,1,6.24-5.67Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_18"
                    data-name="Path 18"
                    d="M370.09,222.31h0l-6.46-.37a4.06,4.06,0,0,1-3.81-4.2l.43-9.76a.19.19,0,0,1,.21-.19.2.2,0,0,1,.19.21l-.42,9.75a3.64,3.64,0,0,0,3.42,3.79l6.46.37a.19.19,0,0,1,.19.21.2.2,0,0,1-.21.19Z"
                    fill="url(#linear-gradient-automations-log)"
                />
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M360.57,205.17h0a.2.2,0,0,1-.19-.21l.07-1.58a.2.2,0,1,1,.4,0l-.07,1.58a.21.21,0,0,1-.21.21Z"
                    fill="url(#linear-gradient-automations-log-2)"
                />
                <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M367.58,139.51c6.84,1.24,30.38,5.15,50,4.49a1.59,1.59,0,0,1,1.65,1.58l.72,73.56a1.83,1.83,0,0,1-1.8,1.85c-8.25.13-42.23.55-54.26-1.24a1.47,1.47,0,0,1-1.24-1.5l2.89-77.1a1.73,1.73,0,0,1,2.04-1.64Z"
                    fill="#717272"
                />
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M368.23,141.45c6.59,1.18,29.24,5,48.13,4.32a1.53,1.53,0,0,1,1.59,1.52l.69,70.79a1.76,1.76,0,0,1-1.73,1.78c-7.94.12-40.64.52-52.22-1.2a1.4,1.4,0,0,1-1.19-1.44l2.78-74.2a1.66,1.66,0,0,1,1.95-1.57Z"
                    fill="#f3f4f5"
                />
                <g id="Group_1" data-name="Group 1" opacity="0.5">
                    <path
                        id="Path_22"
                        data-name="Path 22"
                        d="M413.38,152c.44,0,.8-.19.81-.47s-.36-.53-.8-.56l-17.74-1.09c-.44,0-.7.26-.59.64a1.17,1.17,0,0,0,1,.73Z"
                        fill="#717272"
                    />
                </g>
                <g id="Group_2" data-name="Group 2" opacity="0.5">
                    <path
                        id="Path_23"
                        data-name="Path 23"
                        d="M395.53,152.74c-.44,0-.71.26-.59.64a1.15,1.15,0,0,0,1,.72l17.3.75c.45,0,.81-.19.81-.47s-.35-.53-.79-.56Z"
                        fill="#717272"
                    />
                </g>
                <g id="Group_3" data-name="Group 3" opacity="0.5">
                    <path
                        id="Path_24"
                        data-name="Path 24"
                        d="M395.41,155.6c-.44,0-.71.26-.59.64a1.16,1.16,0,0,0,1,.73l17.3.75c.44,0,.81-.2.81-.48s-.35-.53-.79-.55Z"
                        fill="#717272"
                    />
                </g>
                <g id="Group_4" data-name="Group 4" opacity="0.5">
                    <path
                        id="Path_25"
                        data-name="Path 25"
                        d="M414.64,163.71c.44,0,.8-.2.79-.48s-.37-.53-.81-.55l-42.15-2.16c-.44,0-.59.25-.33.61l.08.11a1.89,1.89,0,0,0,1.28.68Z"
                        fill="#717272"
                    />
                </g>
                <g id="Group_5" data-name="Group 5" opacity="0.5">
                    <path
                        id="Path_26"
                        data-name="Path 26"
                        d="M372.35,163.15c-.44,0-.59.25-.33.61l.08.11a1.87,1.87,0,0,0,1.28.68l41.14,1.79c.44,0,.79-.2.79-.48s-.37-.53-.82-.55Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M378.91,177.53h0l-5.68-.11a1.55,1.55,0,0,1-1.56-1.33l-.44-4.77a1,1,0,0,1,.25-.78,1.28,1.28,0,0,1,.88-.43h0c.48,0,1.14-.07,1.87-.13,1.58-.12,3.37-.25,4.43-.25h0a1.6,1.6,0,0,1,1.57,1.14,24.141,24.141,0,0,1,.15,5.37,1.41,1.41,0,0,1-1.47,1.29Zm-6.53-6.95a.78.78,0,0,0-.56.26.55.55,0,0,0-.14.44l.44,4.77a1.08,1.08,0,0,0,1.11.9l5.67.12h0a1,1,0,0,0,1-.84,23.531,23.531,0,0,0-.14-5.24,1.16,1.16,0,0,0-1.14-.8c-1,0-2.9.14-4.4.25l-1.87.14Z"
                    fill="#717272"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M373,171.06c1.19-.07,3.78-.3,5-.31a1.11,1.11,0,0,1,1.1.78,19.771,19.771,0,0,1,.11,4.24.93.93,0,0,1-1,.85l-4.54-.09a1,1,0,0,1-1.06-.9l-.36-3.81a.73.73,0,0,1,.75-.76Z"
                    fill="#fff"
                />
                <g id="Group_6" data-name="Group 6" opacity="0.5">
                    <path
                        id="Path_29"
                        data-name="Path 29"
                        d="M384.29,172.66a.57.57,0,0,0-.61.75l.32,1.29a1.1,1.1,0,0,0,1,.78l27.91.31a.79.79,0,0,0,.8-.79v-.52a.85.85,0,0,0-.81-.83Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M373.22,171.81h0a.88.88,0,0,1,1.2.34l1.1,2a.28.28,0,0,0,.5,0l2.84-6.15a.31.31,0,0,1,.59.14,12.24,12.24,0,0,1-3.64,8.46s-1.66-.67-3-3.63a.9.9,0,0,1,.41-1.16Z"
                    fill="#717272"
                />
                <path
                    id="Path_31"
                    data-name="Path 31"
                    d="M378.78,189.7h0l-5.67-.12a1.53,1.53,0,0,1-1.56-1.32l-.45-4.77a1.1,1.1,0,0,1,.26-.79,1.25,1.25,0,0,1,.88-.42h0l1.87-.13c1.58-.12,3.37-.25,4.42-.25h0a1.59,1.59,0,0,1,1.57,1.1,23.4,23.4,0,0,1,.16,5.37A1.42,1.42,0,0,1,378.78,189.7Zm-6.53-7a.8.8,0,0,0-.56.26.63.63,0,0,0-.15.45l.45,4.76a1.08,1.08,0,0,0,1.11.91l5.67.12h0a1,1,0,0,0,1-.85,24.192,24.192,0,0,0-.14-5.24,1.15,1.15,0,0,0-1.15-.79c-1,0-2.89.14-4.39.25l-1.87.13Z"
                    fill="#717272"
                />
                <path
                    id="Path_32"
                    data-name="Path 32"
                    d="M372.85,183.23c1.2-.07,3.79-.31,5-.31a1.1,1.1,0,0,1,1.09.77,19.059,19.059,0,0,1,.12,4.24,1,1,0,0,1-1,.86l-4.53-.1a1,1,0,0,1-1.07-.89l-.35-3.81a.73.73,0,0,1,.74-.76Z"
                    fill="#fff"
                />
                <g id="Group_7" data-name="Group 7" opacity="0.5">
                    <path
                        id="Path_33"
                        data-name="Path 33"
                        d="M384.15,184.82a.58.58,0,0,0-.6.76l.32,1.28a1.1,1.1,0,0,0,1,.79l27.91.31a.79.79,0,0,0,.79-.8v-.51a.85.85,0,0,0-.81-.83Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M373.09,184h0a.86.86,0,0,1,1.19.34l1.1,2a.28.28,0,0,0,.5,0l2.85-6.15a.31.31,0,0,1,.59.14,12.18,12.18,0,0,1-3.65,8.45s-1.65-.66-3-3.62A.9.9,0,0,1,373.09,184Z"
                    fill="#717272"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M378.12,201.38h0l-5.67-.12a1.55,1.55,0,0,1-1.56-1.33l-.45-4.76a1.08,1.08,0,0,1,.26-.79,1.25,1.25,0,0,1,.88-.42h0l1.87-.13c1.5-.12,3.37-.25,4.42-.26a1.64,1.64,0,0,1,1.6,1.14,24.2,24.2,0,0,1,.15,5.38,1.42,1.42,0,0,1-1.5,1.29Zm-6.53-7a.8.8,0,0,0-.56.26.62.62,0,0,0-.15.44l.45,4.77a1.08,1.08,0,0,0,1.11.91l5.67.12a1,1,0,0,0,1-.85,23.56,23.56,0,0,0-.14-5.24,1.16,1.16,0,0,0-1.14-.79c-1,0-2.9.14-4.4.25l-1.87.13Z"
                    fill="#717272"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M372.19,194.9c1.2-.07,3.79-.3,5-.3a1.09,1.09,0,0,1,1.09.77,19.059,19.059,0,0,1,.12,4.24.94.94,0,0,1-1,.85l-4.53-.09a1.06,1.06,0,0,1-1.07-.89l-.35-3.81a.73.73,0,0,1,.74-.77Z"
                    fill="#fff"
                />
                <g id="Group_8" data-name="Group 8" opacity="0.5">
                    <path
                        id="Path_37"
                        data-name="Path 37"
                        d="M383.49,196.5a.57.57,0,0,0-.6.75l.32,1.29a1.11,1.11,0,0,0,1,.79l27.91.3a.77.77,0,0,0,.79-.79v-.51a.85.85,0,0,0-.81-.83Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M372.43,195.65h0a.88.88,0,0,1,1.2.34l1.09,2a.28.28,0,0,0,.5,0l2.85-6.16a.31.31,0,0,1,.59.14,12.2,12.2,0,0,1-3.65,8.46s-1.65-.66-3-3.62a.92.92,0,0,1,.42-1.16Z"
                    fill="#717272"
                />
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M377.34,213.42h0l-5.68-.12a1.53,1.53,0,0,1-1.56-1.32l-.44-4.77a1,1,0,0,1,.25-.79,1.27,1.27,0,0,1,.89-.42h0l1.86-.13c1.58-.12,3.38-.25,4.43-.26a1.62,1.62,0,0,1,1.59,1.14,24.2,24.2,0,0,1,.15,5.38,1.41,1.41,0,0,1-1.49,1.29Zm-6.53-7a.82.82,0,0,0-.56.26.61.61,0,0,0-.14.44l.45,4.77a1.07,1.07,0,0,0,1.1.91l5.68.12h0a1,1,0,0,0,1-.85,23.56,23.56,0,0,0-.14-5.24,1.16,1.16,0,0,0-1.14-.79c-1,0-2.9.14-4.39.25l-1.88.13Z"
                    fill="#717272"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M371.42,206.94c1.19-.06,3.79-.3,5-.3a1.11,1.11,0,0,1,1.1.77,19.8,19.8,0,0,1,.11,4.24.93.93,0,0,1-1,.86l-4.54-.1a1,1,0,0,1-1.06-.89l-.36-3.81a.74.74,0,0,1,.75-.77Z"
                    fill="#fff"
                />
                <g id="Group_9" data-name="Group 9" opacity="0.5">
                    <path
                        id="Path_41"
                        data-name="Path 41"
                        d="M382.72,208.54a.57.57,0,0,0-.61.75l.32,1.29a1.11,1.11,0,0,0,1,.79l27.91.3a.79.79,0,0,0,.8-.79v-.51a.84.84,0,0,0-.81-.83Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M371.65,207.69h0a.88.88,0,0,1,1.2.34l1.1,2a.28.28,0,0,0,.5,0l2.84-6.16a.31.31,0,0,1,.59.15,12.2,12.2,0,0,1-3.64,8.45s-1.66-.66-3-3.62a.92.92,0,0,1,.41-1.16Z"
                    fill="#717272"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M396.15,131.36a5.13,5.13,0,0,0-4.48-1.1,2.21,2.21,0,0,0-1.67,2.26l.25,5.27,5.69.76S399.62,134,396.15,131.36Zm-2.7,4.13a1.43,1.43,0,1,1,1.029-.376A1.44,1.44,0,0,1,393.45,135.49Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_44"
                    data-name="Path 44"
                    d="M390.81,135.73a.26.26,0,0,1-.17-.25v-.83a.28.28,0,0,1,.27-.3.27.27,0,0,1,.29.27v.84a.27.27,0,0,1-.27.29.17.17,0,0,1-.12-.02Zm-.08-1.64a.29.29,0,0,1-.17-.25v-.64a2.27,2.27,0,0,1,1.71-2.3,4.39,4.39,0,0,1,2.16,0,.283.283,0,1,1-.13.55,3.78,3.78,0,0,0-1.89,0,1.7,1.7,0,0,0-1.29,1.73v.63a.3.3,0,0,1-.27.3Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_45"
                    data-name="Path 45"
                    d="M382.3,140.84l.11-2.64a1.61,1.61,0,0,1,1.74-1.53l18.15,1.41a1.56,1.56,0,0,1,1.44,1.54l.05,2.54Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_46"
                    data-name="Path 46"
                    d="M389.22,138h-.78a.2.2,0,0,1-.19-.21.21.21,0,0,1,.21-.19h.78a.19.19,0,0,1,.19.2.2.2,0,0,1-.21.2Z"
                    fill="#fff"
                />
                <path
                    id="Path_47"
                    data-name="Path 47"
                    d="M383.21,140.18a.28.28,0,0,1-.17-.27v-1.07a1.64,1.64,0,0,1,1.71-1.57l2.87.13a.28.28,0,1,1-.02.56l-2.88-.12a1.07,1.07,0,0,0-1.12,1v1.07a.28.28,0,0,1-.3.27Z"
                    fill="#fff"
                />
                <path
                    id="Path_48"
                    data-name="Path 48"
                    d="M376.64,139.63l31.8,1.38a2.35,2.35,0,0,1,2.23,2.05v.15a2,2,0,0,1-2.09,2.28L376,144.08a1.32,1.32,0,0,1-1.25-1.44l.13-1.45a1.72,1.72,0,0,1,1.76-1.56Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_49"
                    data-name="Path 49"
                    d="M372.1,164.78,326,173a3.38,3.38,0,0,0-2.68,4.17l.08.31a3.14,3.14,0,0,0,3.84,2.24l45.53-12.12Z"
                    fill="#717272"
                />
                <ellipse
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="21.35"
                    cy="21.74"
                    rx="21.35"
                    ry="21.74"
                    transform="matrix(0.172, -0.985, 0.985, 0.172, 368.636, 176.063)"
                    fill="#717272"
                    opacity="0.05"
                />
                <path
                    id="Path_50"
                    data-name="Path 50"
                    d="M397.79,135.37a23.76,23.76,0,1,0,19.74,27.56,24,24,0,0,0-19.74-27.56Zm-7.58,43.36A20.27,20.27,0,1,1,414,162.32a20.27,20.27,0,0,1-23.79,16.41Z"
                    fill="#717272"
                />
                <path
                    id="Path_51"
                    data-name="Path 51"
                    d="M371.17,157.73a.07.07,0,0,1-.05-.08,13.908,13.908,0,0,1,.14-1.7.09.09,0,0,1,.1-.07.08.08,0,0,1,.07.09c-.07.56-.11,1.13-.14,1.69a.08.08,0,0,1-.09.08Zm1.31-6.51a.08.08,0,0,1-.05-.11,21.715,21.715,0,0,1,2.05-4.16,22.23,22.23,0,0,1,9.78-8.43,23,23,0,0,1,24.63,3.88.09.09,0,0,1-.12.13,22.63,22.63,0,0,0-11.28-5.47,22.38,22.38,0,0,0-22.87,10,22,22,0,0,0-2,4.13.08.08,0,0,1-.11.05Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_52"
                    data-name="Path 52"
                    d="M346,191.2l-4.91,1.23,1.23,9.2a10.51,10.51,0,0,0-2.46,4.29c-.61,2.45-1.17,12.75-1.17,12.75l-1.17.7-.14.59,3.39,4.55-.56-3.62c-.09-.58.06-1.74,0-1.77,1.84-4.9,5.78-18.72,5.78-18.72Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_53"
                    data-name="Path 53"
                    d="M347.46,220h-.16c.24-3,1.32-16,2.4-20.85,1.23-5.51-1.84-16.55-1.84-16.55l-5.51,5.52,3.06,10.42c-2.1,3.15.34,21.61.29,21.6h0l-.8,1.1.09.59,4.89,2.89L348,221.66a3.43,3.43,0,0,1-.54-1.66Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_54"
                    data-name="Path 54"
                    d="M341.25,158.15s-10.74,14.91,0,22.55l1.1-1s-5.34-6.28,0-14Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_55"
                    data-name="Path 55"
                    d="M350.21,225.23h-1.56a.9.9,0,0,1-.74-.37c-.49-.63-1.5-1.86-2-1.89-.65,0-.56,2.26-.56,2.26H345l-.46-2.86a1.73,1.73,0,0,1,.89-1.78h0a2.4,2.4,0,0,0,.95,1.58c.81.49,3.27,2.23,3.27,2.23a2.13,2.13,0,0,1,.64,0,.417.417,0,0,1-.08.83Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_56"
                    data-name="Path 56"
                    d="M340.92,225.05l-1.44-.6a.94.94,0,0,1-.54-.63c-.21-.77-.66-2.3-1.09-2.51-.58-.29-1.4,1.86-1.4,1.86l-.33-.14.68-2.82a1.71,1.71,0,0,1,1.51-1.28h0a2.36,2.36,0,0,0,.27,1.82c.55.76,2.15,3.32,2.15,3.32a2.07,2.07,0,0,1,.58.26.41.41,0,0,1-.39.72Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_57"
                    data-name="Path 57"
                    d="M349.27,173.29a19.87,19.87,0,0,0,.08,4.14c.27,3,1.53,10.17,1.27,17a37,37,0,0,1-9.82.44s-2.64-10.66-2-14.71,4.12-6.95,4.12-6.95Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_58"
                    data-name="Path 58"
                    d="M346.62,152.99l.44,5.16h-4.17l1.03-7.88Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_59"
                    data-name="Path 59"
                    d="M341.65,157.44c1.44-.08,4.66-.23,6.94-.11a2.66,2.66,0,0,1,2.45,2.11l.55,2.66a6.34,6.34,0,0,1-.09,3l-2.23,8.19s-2,1.19-6.34-.08c0,0-3.83-9.13-2.27-15A1.09,1.09,0,0,1,341.65,157.44Z"
                    fill="#717272"
                />
                <path
                    id="Path_60"
                    data-name="Path 60"
                    d="M350.93,159c.61,1.62,1.17,3.31,1.76,4.9.31.79.61,1.57.94,2.29.17.36.35.68.52,1a4,4,0,0,0,.45.65h-.06l.54.09h.52a18.825,18.825,0,0,0,2.4-.33c1.69-.31,3.44-.75,5.24-1.09h0a.64.64,0,0,1,.74.51.62.62,0,0,1-.21.59,17.623,17.623,0,0,1-2.29,1.67c-.4.25-.81.49-1.22.72l-1.29.64a15.737,15.737,0,0,1-2.86,1l-.84.13h-1l-.56-.07h-.29l-.38-.13a3.291,3.291,0,0,1-.65-.33,3.643,3.643,0,0,1-.49-.36,6.72,6.72,0,0,1-1.26-1.45,13.3,13.3,0,0,1-.79-1.4,18.735,18.735,0,0,1-1.08-2.74,25.907,25.907,0,0,1-1.14-5.56,1.67,1.67,0,0,1,3.23-.74Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_61"
                    data-name="Path 61"
                    d="M362.67,167.31l.74-1.77,3.92-1s.31.67-1.33,1a1.42,1.42,0,0,1,.27,1.41C366,167.72,362.63,168.48,362.67,167.31Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_62"
                    data-name="Path 62"
                    d="M348.38,147c.15.09,1.32,4.23.34,6s-4-.21-4.8-2.72S344.42,144.69,348.38,147Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_63"
                    data-name="Path 63"
                    d="M340.6,150.27c-.67,3.3-2.9,2.4-4.48,3.87-2.56,2.37-6.22-.08-9.78,2.18-2.57,1.62-3.81,5.79-2.58,9.15,1.71,4.65,7.55,6.57,10.57,5.15s2.48-5.42,6.38-7c1.65-.67,2.46-.24,3.45-1.22,1.73-1.73,1.27-5.08,1.09-6.37-.39-2.81-1.33-3.31-.88-4.55.87-2.39,4.94-1.9,5.28-3.59.31-1.54-2.64-4.46-5.42-4C339.93,144.63,340.9,148.8,340.6,150.27Z"
                    fill="#5b5b5b"
                />
                <rect
                    id="Rectangle_1"
                    data-name="Rectangle 1"
                    width="1.95"
                    height="21.12"
                    transform="translate(196.87 369.02)"
                    fill="#717272"
                />
                <path
                    id="Path_64"
                    data-name="Path 64"
                    d="M206.4,390.55H189.29v-.7a.58.58,0,0,1,.57-.57h15.92a.62.62,0,0,1,.62.62Z"
                    fill="#717272"
                />
                <rect
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    width="22.86"
                    height="6.48"
                    rx="2.23"
                    transform="translate(186.77 363.99)"
                    fill="#717272"
                />
                <path
                    id="Path_65"
                    data-name="Path 65"
                    d="M187,386.4s-5.58,4-4.61,6.72c0,0,6.1-2.63,6.84-4.7s-.13-3-.13-3Z"
                    fill="#717272"
                />
                <path
                    id="Path_66"
                    data-name="Path 66"
                    d="M187.8,383l.92,2.64a.91.91,0,0,1-.36,1.07,2.331,2.331,0,0,1-.75.3,1.09,1.09,0,0,1-1.19-.54l-1.09-2.05Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M196.68,359.3s-11.46,2-16.37,6.53,4.51,19,4.51,19a5.89,5.89,0,0,0,3.42-1.62s-5.59-10.89-.78-14.06a30.94,30.94,0,0,1,11.66-4.38l-2.33-5.14Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_68"
                    data-name="Path 68"
                    d="M183.33,391.63c1.22-.57,4.7-3,5.28-3.11s1.6.58,1.6.58a1.57,1.57,0,0,1,0,1.22,10.89,10.89,0,0,1-5.05,3.57,4.22,4.22,0,0,1-3.83-.53,5.22,5.22,0,0,1,2-1.73Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_69"
                    data-name="Path 69"
                    d="M185.14,393.89a10.89,10.89,0,0,0,5.05-3.57,4.85,4.85,0,0,1-1.46,2,12.49,12.49,0,0,1-7.24,2.53c-.71-.11-.64-.76-.18-1.48a4.22,4.22,0,0,0,3.83.52Z"
                    fill="#717272"
                />
                <path
                    id="Path_70"
                    data-name="Path 70"
                    d="M191.25,387.39a9.2,9.2,0,0,1-1.11,2.15,1,1,0,0,1-.89.49,3.082,3.082,0,0,1-.73-.08.68.68,0,0,1-.46-.85l.79-2.7Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_71"
                    data-name="Path 71"
                    d="M207.71,355.86s2.54,6.8,0,8.87-8.62,4.4-10,8.52-3.66,12.13-6.74,15a6.1,6.1,0,0,1-3-1.07s1.75-12,2.91-15c1-2.65,2.48-6.49,5.3-8.63.81-.62.67-1.59.3-2.53l-.69-1.72Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_72"
                    data-name="Path 72"
                    d="M181.17,350.53c4.27.26,2.94-6.56,2.86-6.83l6.48,4.57s-.35,3.65-5.73,5.56a6.8,6.8,0,0,1-3.71.27A5.85,5.85,0,0,0,181.17,350.53Z"
                    fill="#717272"
                />
                <path
                    id="Path_73"
                    data-name="Path 73"
                    d="M172.92,348.48a3.29,3.29,0,0,1,3.39,0,10.78,10.78,0,0,0,4.86,2,5.85,5.85,0,0,1-.1,3.57,9.16,9.16,0,0,1-4.82-3.12.77.77,0,0,0-1.07-.12c-.33.26-.65.62-.59,1,.11.74-.75,1-.81.71a10.709,10.709,0,0,1,.29-1.87l-2.39,2.4a1.17,1.17,0,0,1-1.52,0S171.33,349.58,172.92,348.48Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_74"
                    data-name="Path 74"
                    d="M201.06,333.17s-6.2-2.48-17.75,7.05a4.33,4.33,0,0,0,.09,3.78c1,1.78,11.08,10.44,12.45,15.24A14.21,14.21,0,0,0,208,356.58S207.46,343.21,201.06,333.17Z"
                    fill="#717272"
                />
                <path
                    id="Path_75"
                    data-name="Path 75"
                    d="M188.79,331l3.06,3.7A1.23,1.23,0,0,1,192,336a3.48,3.48,0,0,1-3.66,1.95,1.88,1.88,0,0,1-1.54-1.05l-2.14-4.42Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_76"
                    data-name="Path 76"
                    d="M205.87,349c.72-2.94-6.58-9.48-6.58-9.48l1.77-6.39s15.76,10.49,11.75,18.93a6.1,6.1,0,0,1-2.23,2.62A9.81,9.81,0,0,0,205.87,349Z"
                    fill="#717272"
                />
                <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M205.87,348.61a.17.17,0,0,0,.17-.13c.74-3-6.33-9.38-6.63-9.65a.174.174,0,1,0-.23.26c.07.06,7.21,6.51,6.53,9.31a.16.16,0,0,0,.12.2Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_78"
                    data-name="Path 78"
                    d="M194.82,348.78s8.65,3.36,10.76.84a1.44,1.44,0,0,0,.29-.58,9.81,9.81,0,0,1,4.71,5.68c-4.55,2.91-12.33-1.61-14.43-3a1.58,1.58,0,0,0-1.16-.21,11,11,0,0,1-3,.3c-1.11-.17-2.7,3.73-4.49,2.52C187.53,354.38,189.07,347.6,194.82,348.78Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_79"
                    data-name="Path 79"
                    d="M181.17,326.69a23.849,23.849,0,0,0,.6,5.87c.65,1.83.76,3.15,3,2.64a4.75,4.75,0,0,0,3.72-4.45s.33-3.36-.47-4.35S181.17,326.69,181.17,326.69Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_80"
                    data-name="Path 80"
                    d="M187.23,329.77l-.26.11s.15-2.66-1-2.66-5.19.82-6.56-.17a2.69,2.69,0,0,1-.47-3.8.15.15,0,0,1,.21,0l.15.12a.15.15,0,0,0,.25-.13h0a.16.16,0,0,1,.24-.15c.41.3,1.35.66,3.29.24,2.75-.6,4.88-.28,5.66,1.47a.15.15,0,0,0,.26,0c.14-.2.42-.38,1-.21,1,.3,1.3,1.95.29,3.85a.15.15,0,0,0,.1.22c.36.07,1,.32.12,1.35a3.1,3.1,0,0,1-1.8,1.3.15.15,0,0,1-.17-.1l-.56-1.6a.14.14,0,0,0-.2-.09Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_81"
                    data-name="Path 81"
                    d="M187.3,330.12s-.35-2.41.89-2.21.51,2.65-.24,3.06Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_82"
                    data-name="Path 82"
                    d="M158.32,394.35a.771.771,0,0,1-.3-.06.73.73,0,0,1-.4-1l16-36a.76.76,0,0,1,1-.39.73.73,0,0,1,.4,1l-16,36a.78.78,0,0,1-.7.45Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_83"
                    data-name="Path 83"
                    d="M176.34,394.35a.78.78,0,0,1-.7-.45l-16-36a.73.73,0,0,1,.4-1,.76.76,0,0,1,1,.39l16,36a.73.73,0,0,1-.4,1,.8.8,0,0,1-.3.06Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_84"
                    data-name="Path 84"
                    d="M207.84,394.35a.8.8,0,0,1-.3-.06.74.74,0,0,1-.4-1l16-36a.78.78,0,0,1,1-.39.74.74,0,0,1,.4,1l-16,36a.78.78,0,0,1-.7.45Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_85"
                    data-name="Path 85"
                    d="M225.87,394.35a.76.76,0,0,1-.7-.45l-16-36a.73.73,0,0,1,.4-1,.77.77,0,0,1,1,.39l16,36a.73.73,0,0,1-.4,1,.8.8,0,0,1-.3.06Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_86"
                    data-name="Path 86"
                    d="M227.75,356.2a.87.87,0,0,0-.16-.67.67.67,0,0,0-.55-.29H154.25a.82.82,0,0,0-.7.42,1,1,0,0,0-.05.89l.79,1.91a1.1,1.1,0,0,0,1,.72h71.25a.87.87,0,0,0,.82-.76Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_87"
                    data-name="Path 87"
                    d="M190.38,355.41H172.23a.82.82,0,0,1-.82-.81.83.83,0,0,1,.82-.82h18.15a.82.82,0,0,1,0,1.63Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_88"
                    data-name="Path 88"
                    d="M155.87,338.93H171a2.87,2.87,0,0,1,2.6,1.65l7,14.82H161.79a1.76,1.76,0,0,1-1.63-1.11l-5.42-13.71a1.21,1.21,0,0,1,1.13-1.65Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_89"
                    data-name="Path 89"
                    d="M166.52,346.52c.33,1,.08,2-.54,2.21s-1.4-.46-1.73-1.48-.09-2,.54-2.2S166.19,345.51,166.52,346.52Z"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="2.37"
                    height="25.59"
                    transform="translate(399.3 260.35)"
                    fill="#636363"
                />
                <path
                    id="Path_90"
                    data-name="Path 90"
                    d="M390.12,286.43h20.73a1.54,1.54,0,0,0-1.54-1.54H391.66A1.54,1.54,0,0,0,390.12,286.43Z"
                    fill="#636363"
                />
                <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="27.69"
                    height="7.85"
                    rx="2.7"
                    transform="translate(386.2 254.25)"
                    fill="#636363"
                />
                <path
                    id="Path_91"
                    data-name="Path 91"
                    d="M410.31,278.09s5.93,4.27,4.9,7.14c0,0-6.49-2.8-7.27-5s.13-3.18.13-3.18Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_92"
                    data-name="Path 92"
                    d="M409.42,274.5l-1,2.81a1,1,0,0,0,.38,1.14,2.56,2.56,0,0,0,.8.31,1.15,1.15,0,0,0,1.26-.57l1.16-2.18Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_93"
                    data-name="Path 93"
                    d="M400,249.26s12.18,2.12,17.41,6.94-4.8,20.23-4.8,20.23a6.25,6.25,0,0,1-3.63-1.71s5.94-11.59.82-15a33,33,0,0,0-12.39-4.66l2.47-5.46Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_94"
                    data-name="Path 94"
                    d="M414.18,283.65c-1.3-.61-5-3.19-5.62-3.31s-1.7.62-1.7.62a1.64,1.64,0,0,0,0,1.3,11.57,11.57,0,0,0,5.38,3.79,4.49,4.49,0,0,0,4.06-.56,5.45,5.45,0,0,0-2.12-1.84Z"
                    fill="#717272"
                />
                <path
                    id="Path_95"
                    data-name="Path 95"
                    d="M412.26,286.05a11.57,11.57,0,0,1-5.38-3.79,5.22,5.22,0,0,0,1.56,2.11,13.2,13.2,0,0,0,7.69,2.69c.76-.11.69-.81.19-1.57a4.49,4.49,0,0,1-4.06.56Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_96"
                    data-name="Path 96"
                    d="M405.75,279.13a10.21,10.21,0,0,0,1.18,2.29,1.11,1.11,0,0,0,.95.53,3,3,0,0,0,.78-.09.73.73,0,0,0,.49-.91l-.84-2.86Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_97"
                    data-name="Path 97"
                    d="M388.25,245.61s-2.7,7.23,0,9.43,9.16,4.68,10.6,9.06S402.74,277,406,280c0,0,2.3-.23,3.16-1.14,0,0-1.87-12.72-3.1-16-1.06-2.82-2.63-6.9-5.64-9.18-.86-.65-.71-1.69-.31-2.69l.73-1.83Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_98"
                    data-name="Path 98"
                    d="M416.47,239.94c-4.54.27-3.12-7-3-7.27l-6.89,4.87s.37,3.87,6.09,5.91a7.19,7.19,0,0,0,3.95.28,6.26,6.26,0,0,1-.15-3.79Z"
                    fill="#636363"
                />
                <path
                    id="Path_99"
                    data-name="Path 99"
                    d="M425.24,237.75a3.51,3.51,0,0,0-3.6,0,11.51,11.51,0,0,1-5.17,2.19,6.26,6.26,0,0,0,.11,3.79,9.74,9.74,0,0,0,5.13-3.32.83.83,0,0,1,1.13-.12c.35.28.69.66.63,1.06-.12.79.8,1,.87.75a12.8,12.8,0,0,0-.32-2l2.55,2.55a1.26,1.26,0,0,0,1.62,0S426.93,238.93,425.24,237.75Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_100"
                    data-name="Path 100"
                    d="M395.32,221.48s6.6-2.64,18.88,7.5a4.6,4.6,0,0,1-.09,4c-1.12,1.89-11.79,11.1-13.25,16.21a15.07,15.07,0,0,1-12.93-2.83S388.51,232.15,395.32,221.48Z"
                    fill="#636363"
                />
                <path
                    id="Path_101"
                    data-name="Path 101"
                    d="M408.36,219.12l-3.24,3.94a1.29,1.29,0,0,0-.18,1.39,3.71,3.71,0,0,0,3.9,2.07,2,2,0,0,0,1.64-1.11l2.27-4.7Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_102"
                    data-name="Path 102"
                    d="M390.21,238.35c-.77-3.12,7-10.08,7-10.08l-1.88-6.79s-16.76,11.16-12.49,20.13a6.55,6.55,0,0,0,2.37,2.79,10.43,10.43,0,0,1,5-6.05Z"
                    fill="#636363"
                />
                <path
                    id="Path_103"
                    data-name="Path 103"
                    d="M390.2,237.89a.18.18,0,0,1-.18-.13c-.78-3.2,6.73-10,7.05-10.26a.184.184,0,1,1,.25.27c-.08.07-7.67,6.92-6.94,9.9a.18.18,0,0,1-.14.22Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_104"
                    data-name="Path 104"
                    d="M402,238.08s-9.2,3.57-11.45.89a1.49,1.49,0,0,1-.3-.62,10.43,10.43,0,0,0-5,6.05c4.84,3.09,13.11-1.72,15.35-3.14a1.61,1.61,0,0,1,1.23-.23,11.511,11.511,0,0,0,3.16.32c1.17-.18,2.86,4,4.77,2.69C409.71,244,408.08,236.83,402,238.08Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_105"
                    data-name="Path 105"
                    d="M415.43,213.33c0,.1-.45,5.73-.71,8.79a1.59,1.59,0,0,1-.69,1.18,1.56,1.56,0,0,1-1.34.21l-2-.6a3,3,0,0,1-1.71-1.27c-.19-.3-.39-.59-.61-.93l1-7.47S414.89,211.21,415.43,213.33Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_106"
                    data-name="Path 106"
                    d="M415,209.35a1.82,1.82,0,0,0-2,1.28.61.61,0,0,1-.82.35.47.47,0,0,0-.55,0,.6.6,0,0,1-.78,0,2.25,2.25,0,0,0-2.73-.35,1.59,1.59,0,0,0-.64,2.28.62.62,0,0,1-.3.83,1.58,1.58,0,0,0-.81,2.41.61.61,0,0,0,.37.3c.48.14,1.61.54,1.8,1.4a.493.493,0,0,0,.06.27,8.489,8.489,0,0,1,1.88-.31l.06-2.88a.64.64,0,0,1,.24-.47,2.59,2.59,0,0,1,2.48-.6c1.23.57,3.59.85,4-.61S417.22,209.48,415,209.35Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_107"
                    data-name="Path 107"
                    d="M408.56,219.47s.61-2.56-.36-3.07-2.28,0-1.79,1.71C407,220.3,408.56,219.47,408.56,219.47Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_108"
                    data-name="Path 108"
                    d="M406.68,245.13h19.31a.87.87,0,0,0,.86-.87.85.85,0,0,0-.86-.86H406.68a.85.85,0,0,0-.86.86.87.87,0,0,0,.86.87Z"
                    fill="#717272"
                />
                <path
                    id="Path_109"
                    data-name="Path 109"
                    d="M443.38,227.6H427.3a3.07,3.07,0,0,0-2.77,1.75l-7.43,15.77h20a1.86,1.86,0,0,0,1.73-1.18l5.77-14.59a1.28,1.28,0,0,0-1.22-1.75Z"
                    fill="#717272"
                />
                <path
                    id="Path_110"
                    data-name="Path 110"
                    d="M432.06,235.68c-.35,1.08-.1,2.13.57,2.35s1.49-.49,1.84-1.58.09-2.13-.58-2.34S432.4,234.6,432.06,235.68Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_111"
                    data-name="Path 111"
                    d="M440.78,286.54a1,1,0,0,0,.32-.07.77.77,0,0,0,.42-1l-17-38.3a.84.84,0,0,0-1.07-.41.78.78,0,0,0-.42,1l17,38.29a.81.81,0,0,0,.75.49Z"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_112"
                    data-name="Path 112"
                    d="M421.61,286.54a.81.81,0,0,0,.74-.48l17-38.29a.78.78,0,0,0-.43-1,.82.82,0,0,0-1.06.41l-17,38.3a.78.78,0,0,0,.43,1A.881.881,0,0,0,421.61,286.54Z"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_113"
                    data-name="Path 113"
                    d="M388.11,286.54a1,1,0,0,0,.32-.07.77.77,0,0,0,.42-1l-17-38.3a.84.84,0,0,0-1.07-.41.79.79,0,0,0-.43,1l17,38.29a.81.81,0,0,0,.76.49Z"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_114"
                    data-name="Path 114"
                    d="M368.94,286.54a.81.81,0,0,0,.74-.48l17-38.29a.78.78,0,0,0-.43-1,.82.82,0,0,0-1.06.41l-17,38.3a.78.78,0,0,0,.43,1,.88.88,0,0,0,.32.06Z"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_115"
                    data-name="Path 115"
                    d="M366.94,246a1,1,0,0,1,.16-.71.76.76,0,0,1,.59-.31H445.1a.85.85,0,0,1,.74.46,1,1,0,0,1,.06.94l-.84,2a1.17,1.17,0,0,1-1.06.77H368.22a.92.92,0,0,1-.87-.81Z"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_116"
                    data-name="Path 116"
                    d="M221.07,133.21,164.35,133a1,1,0,0,0-1,1l.12,19.85a1,1,0,0,0,1,1c5-.15,56.27-.81,57.25-.77s.44-15.64.3-19.84A1,1,0,0,0,221.07,133.21Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_117"
                    data-name="Path 117"
                    d="M164.47,154a.22.22,0,0,1-.22-.21l-.12-19.86a.21.21,0,0,1,.21-.21l56.73.25a.22.22,0,0,1,.21.2c.36,10.45.36,17,0,19v.08h-.08l-8.2.11c-14.71.18-45.33.56-48.53.66Zm0-.21h0c3.2-.1,33.82-.48,48.54-.66l8.11-.11c.33-2,.32-8.55,0-18.85l-56.74-.26.11,19.87Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_118"
                    data-name="Path 118"
                    d="M218.65,138.34h0c0,.53-.18,1-.4,1H196.52c-.22,0-.4-.44-.4-1h0c0-.54.18-1,.4-1h21.73C218.47,137.36,218.65,137.8,218.65,138.34Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_119"
                    data-name="Path 119"
                    d="M218.65,141.65h0c0,.54-.18,1-.4,1H196.52c-.22,0-.4-.43-.4-1h0c0-.54.18-1,.4-1h21.73C218.47,140.68,218.65,141.11,218.65,141.65Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_120"
                    data-name="Path 120"
                    d="M218.65,145h0c0,.54-.18,1-.4,1H196.52c-.22,0-.4-.44-.4-1h0c0-.53.18-1,.4-1h21.73C218.47,144,218.65,144.43,218.65,145Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_121"
                    data-name="Path 121"
                    d="M218.65,148.28h0c0,.53-.18,1-.4,1H196.52c-.22,0-.4-.44-.4-1h0c0-.54.18-1,.4-1h21.73C218.47,147.31,218.65,147.74,218.65,148.28Z"
                    fill="#e3e2e2"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="3.78"
                    cy="3.78"
                    r="3.78"
                    transform="translate(186.83 135.24)"
                    fill="#f3f4f5"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="3.78"
                    cy="3.78"
                    r="3.78"
                    transform="translate(177.44 135.24)"
                    fill="#f3f4f5"
                />
                <circle
                    id="Ellipse_4"
                    data-name="Ellipse 4"
                    cx="3.78"
                    cy="3.78"
                    r="3.78"
                    transform="translate(168.05 135.36)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_122"
                    data-name="Path 122"
                    d="M188.37,138.22a2.39,2.39,0,0,0-.18.92,2.43,2.43,0,1,0,2.42-2.42h-.12v-.62h.12a2.99,2.99,0,1,1-2.77,1.84Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_123"
                    data-name="Path 123"
                    d="M180,141.2a2.46,2.46,0,0,0,1.29.37,2.43,2.43,0,1,0,0-4.85h-.12v-.62h.12a3,3,0,1,1-1.6,5.63Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_124"
                    data-name="Path 124"
                    d="M169.8,140.51a2.43,2.43,0,1,0,2-3.79h-.12v-.62h.12a3,3,0,1,1-2.51,4.77Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_125"
                    data-name="Path 125"
                    d="M187.53,144.4h6.16a.7.7,0,0,1,0,1.4h-6.16a.7.7,0,1,1,0-1.4Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_126"
                    data-name="Path 126"
                    d="M178.14,144.4h6.16a.7.7,0,1,1,0,1.4h-6.16a.7.7,0,1,1,0-1.4Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_127"
                    data-name="Path 127"
                    d="M174.91,145.8h-6.16a.7.7,0,0,1,0-1.4h6.16a.7.7,0,0,1,0,1.4Z"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="7.56"
                    height="5.52"
                    rx="0.7"
                    transform="translate(186.83 146.58)"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_6"
                    data-name="Rectangle 6"
                    width="7.56"
                    height="5.52"
                    rx="0.7"
                    transform="translate(177.44 146.58)"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_7"
                    data-name="Rectangle 7"
                    width="7.56"
                    height="5.52"
                    rx="0.7"
                    transform="translate(168.05 146.58)"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_8"
                    data-name="Rectangle 8"
                    width="1.68"
                    height="18.13"
                    transform="translate(139.86 191.31)"
                    fill="#717272"
                />
                <path
                    id="Path_128"
                    data-name="Path 128"
                    d="M133.36,209.79H148v-.42a.67.67,0,0,0-.67-.67H134a.66.66,0,0,0-.66.67Z"
                    fill="#717272"
                />
                <rect
                    id="Rectangle_9"
                    data-name="Rectangle 9"
                    width="18.47"
                    height="5.24"
                    rx="1.8"
                    transform="translate(131.18 187.24)"
                    fill="#717272"
                />
                <path
                    id="Path_129"
                    data-name="Path 129"
                    d="M153.08,179.22a14.51,14.51,0,0,1,5.29,2.25,1.42,1.42,0,0,1,.62,1.34,59.33,59.33,0,0,1-6.27,19.66,2.14,2.14,0,0,0-.2,1.45l.79,3.68,1.47,1.37H151l-2.51-6.8,1.07-.34a2,2,0,0,0,1.42-1.9l.13-7.3a8.28,8.28,0,0,1,2-5.49l-6-.3Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_130"
                    data-name="Path 130"
                    d="M156.25,209.63c.34.45-3.7,1.05-5.74.06,0,0-2.83-4.92-2.83-7.46,0,0,.22-.52,1.88-.4,0,0,1,5.83,2,6.49s2.81.06,2.81.06a6,6,0,0,1,1.88,1.25Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_131"
                    data-name="Path 131"
                    d="M147.84,187.24c0-.05,6.49-.77,6.49-.77a14.92,14.92,0,0,0,.45,4.66c.66,2.71,10.14,14.42,10.14,14.42l-1,3.15a16,16,0,0,0,9.07.54l-6.16-3.69s-5.77-19.65-9.3-23.16l-6.47-2.24Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_132"
                    data-name="Path 132"
                    d="M133.36,175.81s-3.73,5.53-4,8.06,1,3.55,4.92,3.72,14.33.16,14.33.16l8.89-7.6s-6.48-2.31-8.16-3S133.36,175.81,133.36,175.81Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_133"
                    data-name="Path 133"
                    d="M164.3,207.64a1.82,1.82,0,0,0-.35,2.19s8.48,1.5,10.78.82c0,0-.47-1.09-3.07-2.33l.2.14a.31.31,0,0,1-.21.56C169.94,208.92,166.41,208.61,164.3,207.64Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_134"
                    data-name="Path 134"
                    d="M143.42,175.08a85.349,85.349,0,0,0,6.46-6.86,5.76,5.76,0,0,0,1-5.22,71.007,71.007,0,0,0-2.86-7.21c-.24-.81-5.1-.77-5.1-.77s-9.56,6.2-13.31,16.71l4.22,1.31a49.321,49.321,0,0,1,5-6.85s-4.27,5.64-4.42,7.95Z"
                    fill="#717272"
                />
                <path
                    id="Path_135"
                    data-name="Path 135"
                    d="M148.59,151.26c-.05.17-1.32,4.38-1.42,4.46a7.08,7.08,0,0,1-4-.63l2.14-4.48Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_136"
                    data-name="Path 136"
                    d="M146.51,142.43a8.56,8.56,0,0,1,3.84,4.28c1.56,3.31.4,4.83-1.06,5a6.84,6.84,0,0,1-6-2C141,147.66,143.53,141.29,146.51,142.43Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_137"
                    data-name="Path 137"
                    d="M144.89,148s-1.73-4.84,2.56-4.9l1,.71s1.57-2.69-1-4a5.5,5.5,0,0,0-7.54,3.34c-1.1,3.49-.45,5.73,1.37,7.4s2.59-.22,2.59-.22-1-1.56-.59-2.4,1.34.18,1.34.18Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_138"
                    data-name="Path 138"
                    d="M144.41,148.57s-.88-2.5-2-1.5.94,2.3,1.77,2.72Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_139"
                    data-name="Path 139"
                    d="M152.24,175.38l-3.18-3.06-4.4,1.86s-4.39.67-6.89,0l-2.51-.68-5.67-1.77-.89,2.52a1.51,1.51,0,0,0,.55,1.74,10.14,10.14,0,0,0,1.43.89c.75.33,18.41-.23,18.41-.23Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_140"
                    data-name="Path 140"
                    d="M140.25,143.76a1,1,0,0,0-.59-1.64c-2.51-.39-6.35,0-8,5.4-1.81,6.06-3,9.09-4.21,9.63a1,1,0,0,0,0,1.81,4.24,4.24,0,0,0,2.63.09C139.33,157,137,147.07,140.25,143.76Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_141"
                    data-name="Path 141"
                    d="M140.2,176.83h18.47a.83.83,0,0,0,0-1.65H140.21a.83.83,0,0,0,0,1.65Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_142"
                    data-name="Path 142"
                    d="M175.31,160.06H159.93a2.93,2.93,0,0,0-2.65,1.68l-7.11,15.08h19.11a1.79,1.79,0,0,0,1.66-1.13l5.51-13.95a1.23,1.23,0,0,0-1.14-1.68Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_143"
                    data-name="Path 143"
                    d="M164.47,167.79c-.33,1-.09,2,.55,2.25s1.43-.47,1.76-1.5.09-2-.55-2.25S164.81,166.76,164.47,167.79Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_144"
                    data-name="Path 144"
                    d="M114.39,177.5a.66.66,0,0,1,.16-.59.79.79,0,0,1,.59-.26h77.05a.91.91,0,0,1,.74.38.78.78,0,0,1,.06.79l-.83,1.7a1.2,1.2,0,0,1-1.07.63H115.66a.86.86,0,0,1-.86-.67Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_145"
                    data-name="Path 145"
                    d="M187.88,213.21a.62.62,0,0,0,.26-.06.69.69,0,0,0,.36-.9l-14.19-33.74a.66.66,0,0,0-.88-.36.69.69,0,0,0-.36.91l14.18,33.73A.68.68,0,0,0,187.88,213.21Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_146"
                    data-name="Path 146"
                    d="M171.9,213.21a.68.68,0,0,0,.62-.42l14.18-33.73a.7.7,0,0,0-.35-.91.67.67,0,0,0-.89.36l-14.18,33.74a.69.69,0,0,0,.35.9A.66.66,0,0,0,171.9,213.21Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_147"
                    data-name="Path 147"
                    d="M132,213.21a.58.58,0,0,0,.26-.06.69.69,0,0,0,.36-.9l-14.19-33.74a.66.66,0,0,0-.88-.36.69.69,0,0,0-.36.91l14.18,33.73A.68.68,0,0,0,132,213.21Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_148"
                    data-name="Path 148"
                    d="M116.05,213.21a.68.68,0,0,0,.62-.42l14.18-33.73a.7.7,0,0,0-.35-.91.67.67,0,0,0-.89.36l-14.18,33.74a.69.69,0,0,0,.35.9.66.66,0,0,0,.27.06Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_149"
                    data-name="Path 149"
                    d="M121.58,309.73h.19a1.6,1.6,0,0,0,1.41-1.77L113.1,220.22a1.61,1.61,0,1,0-3.19.37L120,308.3A1.61,1.61,0,0,0,121.58,309.73Z"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_150"
                    data-name="Path 150"
                    d="M66.17,309.73a1.61,1.61,0,0,0,1.57-1.26L87.4,220.76a1.6,1.6,0,1,0-3.13-.71L64.6,307.77a1.62,1.62,0,0,0,1.22,1.92A2.208,2.208,0,0,0,66.17,309.73Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_151"
                    data-name="Path 151"
                    d="M99.38,309.73a1.61,1.61,0,0,0,1.61-1.61V264.83a1.61,1.61,0,0,0-3.21,0v43.29a1.61,1.61,0,0,0,1.6,1.61Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_152"
                    data-name="Path 152"
                    d="M131.52,210.59l-5.65,71.11a2.84,2.84,0,0,1-2.9,2.62l-59-1.44a2.84,2.84,0,0,1-2.74-3.29l11.29-70.9a2.84,2.84,0,0,1,2.87-2.4l53.32,1.24a2.83,2.83,0,0,1,2.81,3.06Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_153"
                    data-name="Path 153"
                    d="M126.58,209.48l-49.44-1.14a2.84,2.84,0,0,0-2.87,2.39L63.61,277.64a2.84,2.84,0,0,0,2.74,3.29l54.77,1.33a2.83,2.83,0,0,0,2.9-2.61l5.33-67.1a2.84,2.84,0,0,0-2.77-3.07Z"
                    fill="#fff"
                />
                <path
                    id="Path_154"
                    data-name="Path 154"
                    d="M99.9,216.33l24.92,1.39a.45.45,0,0,1,.43.49v.4a.44.44,0,0,1-.48.41l-24.89-1.79a.46.46,0,0,1-.42-.49h0a.45.45,0,0,1,.44-.41Z"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_10"
                    data-name="Rectangle 10"
                    width="1.08"
                    height="25.86"
                    rx="0.45"
                    transform="translate(99.185 219.427) rotate(-85.1)"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_155"
                    data-name="Path 155"
                    d="M106.6,221.7v.08a.46.46,0,0,0,.41.49l17.32,1.48a.45.45,0,0,0,.49-.41v-.35a.45.45,0,0,0-.42-.49l-17.34-1.21a.44.44,0,0,0-.46.41Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_156"
                    data-name="Path 156"
                    d="M118.16,237.43a.29.29,0,0,1-.21-.09l-7.67-7.43-8.66,5.24a.3.3,0,0,1-.4-.09L91.09,220.47l-11.57,8.46a.29.29,0,0,1-.42-.07.3.3,0,0,1,.06-.42L91,219.8a.32.32,0,0,1,.23-.06.34.34,0,0,1,.2.13l10.14,14.62,8.62-5.22a.32.32,0,0,1,.37,0l7.64,7.42,4.73-3.44a.3.3,0,0,1,.36.48l-4.94,3.6a.27.27,0,0,1-.19.1Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_157"
                    data-name="Path 157"
                    d="M89.3,243.27h0a.2.2,0,0,1-.18-.22v-.29a.2.2,0,0,1,.4,0v.29a.2.2,0,0,1-.22.22Zm.15-1.69h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.4,0v.6a.2.2,0,0,1-.22.22Zm.17-2h0a.2.2,0,0,1-.19-.22l.06-.6a.19.19,0,0,1,.21-.18.21.21,0,0,1,.19.22l-.06.6a.2.2,0,0,1-.21.18Zm.18-2h0a.2.2,0,0,1-.18-.22l.05-.6a.2.2,0,0,1,.4,0v.6a.2.2,0,0,1-.27.22Zm.18-2h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.4,0v.6a.2.2,0,0,1-.2.22Zm.17-2h0a.2.2,0,0,1-.18-.22l.06-.6a.19.19,0,0,1,.21-.18.21.21,0,0,1,.19.22l-.06.6a.2.2,0,0,1-.22.18Zm.18-2h0a.2.2,0,0,1-.18-.22l.05-.6a.2.2,0,0,1,.4,0v.6a.2.2,0,0,1-.27.22Zm.18-2h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.4,0l-.05.6a.2.2,0,0,1-.17.22Zm.17-2h0a.2.2,0,0,1-.18-.22l.06-.6a.19.19,0,0,1,.21-.18.21.21,0,0,1,.19.22l-.06.6a.2.2,0,0,1-.22.18Zm.18-2h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.4,0v.6a.2.2,0,0,1-.22.22Zm.18-2h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.4,0l-.05.6a.2.2,0,0,1-.21.22Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_158"
                    data-name="Path 158"
                    d="M100.69,243.88h0a.2.2,0,0,1-.18-.22h0a.2.2,0,0,1,.4,0h0a.2.2,0,0,1-.22.22Zm.13-1.43h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.4,0v.6a.2.2,0,0,1-.22.22Zm.17-2h0a.21.21,0,0,1-.19-.22l.06-.6a.19.19,0,0,1,.21-.18.2.2,0,0,1,.19.22l-.06.6a.19.19,0,0,1-.2.18Zm.18-2h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.4,0v.6a.2.2,0,0,1-.22.22Zm.18-2h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.4,0v.6a.2.2,0,0,1-.22.22Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_159"
                    data-name="Path 159"
                    d="M109.38,243.69h0a.2.2,0,0,1-.19-.21v-.61a.2.2,0,0,1,.22-.18.19.19,0,0,1,.18.21v.6a.2.2,0,0,1-.21.19Zm.11-2h0a.2.2,0,0,1-.19-.21v-.6a.2.2,0,0,1,.4,0v.6a.21.21,0,0,1-.21.2Zm.12-2h0a.2.2,0,0,1-.19-.21v-.6a.2.2,0,1,1,.4.02v.6a.21.21,0,0,1-.21.18Zm.11-2h0a.2.2,0,0,1-.19-.21v-.6a.2.2,0,0,1,.21-.19.21.21,0,0,1,.19.21v.61a.19.19,0,0,1-.21.16Zm.12-2h0a.2.2,0,0,1-.19-.21v-.6a.21.21,0,0,1,.21-.19.19.19,0,0,1,.19.21v.6a.21.21,0,0,1-.21.17Zm.11-2h0a.2.2,0,0,1-.19-.21v-.6a.2.2,0,0,1,.21-.19.21.21,0,0,1,.19.21v.61a.19.19,0,0,1-.16.15Zm.12-2h0a.19.19,0,0,1-.19-.21v-.6a.2.2,0,0,1,.21-.19.19.19,0,0,1,.19.21v.6a.21.21,0,0,1-.21.16Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_160"
                    data-name="Path 160"
                    d="M117.64,244.48h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.22-.18.19.19,0,0,1,.18.21v.6a.21.21,0,0,1-.22.19Zm.17-2h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.22-.18.19.19,0,0,1,.18.21v.6a.21.21,0,0,1-.22.19Zm.18-2h0a.2.2,0,0,1-.18-.22v-.6a.2.2,0,0,1,.22-.18.19.19,0,0,1,.18.21v.6a.21.21,0,0,1-.21.19Zm.18-2h0a.2.2,0,0,1-.19-.21l.06-.6a.22.22,0,0,1,.22-.19.2.2,0,0,1,.18.22v.6a.21.21,0,0,1-.27.18Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_161"
                    data-name="Path 161"
                    d="M77.07,243.59h0a.32.32,0,0,1-.27-.33l2.69-26.92a.3.3,0,0,1,.33-.27.29.29,0,0,1,.27.33L77.4,243.32a.3.3,0,0,1-.33.27Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_162"
                    data-name="Path 162"
                    d="M78.63,217.46l1.12-.92.91,1.12.09-.86-.92-1.12-1.12.92Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_163"
                    data-name="Path 163"
                    d="M123.13,246.36h0l-47.7-4.21a.31.31,0,0,1-.27-.33.29.29,0,0,1,.33-.27l47.7,4.21a.3.3,0,1,1-.06.6Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_164"
                    data-name="Path 164"
                    d="M121.84,246.97l1.11-.93-.93-1.11.87.08.93,1.11-1.11.92Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_165"
                    data-name="Path 165"
                    d="M83.26,309.35a.53.53,0,0,0,0-.13c-.67-2.64-4-4.29-4-4.29L78,305a9.07,9.07,0,0,0-.53,4.38.07.07,0,0,0,0,.05A31.092,31.092,0,0,0,83.26,309.35Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_166"
                    data-name="Path 166"
                    d="M77.45,309.47a.55.55,0,0,0,.41.42,17.53,17.53,0,0,0,5-.07.47.47,0,0,0,.39-.47A31.09,31.09,0,0,1,77.45,309.47Z"
                    fill="#717272"
                />
                <path
                    id="Path_167"
                    data-name="Path 167"
                    d="M96.52,224.32l8.63-3.13.66,1.39-8.29,3.13a1.15,1.15,0,0,1-1-1.39Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_168"
                    data-name="Path 168"
                    d="M105.15,221.19c-.26.77.66,1.39.66,1.39l1.56-1.1a3.46,3.46,0,0,1-.16-.61Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_169"
                    data-name="Path 169"
                    d="M107.21,220.87a3.46,3.46,0,0,0,.16.61l1.16-.82Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_170"
                    data-name="Path 170"
                    d="M72.27,262.65a12.12,12.12,0,0,1-2.84,2.07,23.539,23.539,0,0,0,5.18,4.61l.65,1.44,2-2.46a11.15,11.15,0,0,1-4.99-5.66Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_171"
                    data-name="Path 171"
                    d="M77.44,303.09l.56,2.67a.42.42,0,0,0,.37.35,3.12,3.12,0,0,0,.86,0,.53.53,0,0,0,.43-.64l-.38-2.37Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_172"
                    data-name="Path 172"
                    d="M88.93,309.45a7.73,7.73,0,0,1-2.58-.37v.44a.3.3,0,0,0,.28.29l7.93-.05a.36.36,0,0,0,.29-.53,58.988,58.988,0,0,1-5.92.22Z"
                    fill="#717272"
                />
                <path
                    id="Path_173"
                    data-name="Path 173"
                    d="M94.85,309.23v-.06a10.06,10.06,0,0,0-6-3.77l-1.69-.06a8,8,0,0,0-.77,3.74,7.73,7.73,0,0,0,2.58.37q2.944.037,5.88-.22Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_174"
                    data-name="Path 174"
                    d="M86.8,302.78c0,.13.25,2,.34,2.79a.38.38,0,0,0,.31.33,4.22,4.22,0,0,0,1.17,0,.5.5,0,0,0,.38-.5v-3Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_175"
                    data-name="Path 175"
                    d="M85.45,267.79a150.521,150.521,0,0,1,4,35,.75.75,0,0,1-.6.74,8.449,8.449,0,0,1-1.89.22.71.71,0,0,1-.67-.59c-.57-3.35-3.85-22.26-5.72-25.33,0,0-1.23,16.84-.84,25.58a.42.42,0,0,1-.37.43,7,7,0,0,1-1.52,0,.55.55,0,0,1-.49-.47c-.41-2.84-2.75-19.74-2.65-31.92,0-.69,1.81-3.68,1.81-3.68Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_176"
                    data-name="Path 176"
                    d="M98.79,234.39C97,237.73,94,241.13,89.19,242c-4.47.84-12.49,1.88-15.71,2.29a4,4,0,0,0-2.5,1.34c-2.53,2.93-8.09,11-1.55,19.05a12.12,12.12,0,0,0,2.84-2.07A10,10,0,0,1,73,254.8a2.953,2.953,0,0,0,.19.75A46.07,46.07,0,0,1,75.39,269a.42.42,0,0,0,.27.39c2.75,1.11,8,.45,9.83.19a.61.61,0,0,0,.5-.68c-.88-6.33,3.6-16.73,4.79-19.34a1.72,1.72,0,0,1,.86-.86c6.76-3.06,9.71-7.77,10.9-12A6.48,6.48,0,0,0,98.79,234.39Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_177"
                    data-name="Path 177"
                    d="M102.54,236.64a20.61,20.61,0,0,0,.32-9.6h-1.54a25,25,0,0,1-2.53,7.35,6.48,6.48,0,0,1,3.75,2.25Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_178"
                    data-name="Path 178"
                    d="M101.86,227.86s-2.35-3-1.58-4.62,3.37-1.43,3.37-1.43l.37,1.24a1.53,1.53,0,0,1,0,1l-1.44,3.82Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_179"
                    data-name="Path 179"
                    d="M78.23,238.25l-.53,5.42a6.817,6.817,0,0,0,5.27-.65l-1.56-4.93Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_180"
                    data-name="Path 180"
                    d="M81.77,232.07c.07.07,3.1,6,3.1,6l-3.43,1.65-3.7-5.2S80.54,230.91,81.77,232.07Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_181"
                    data-name="Path 181"
                    d="M79.26,234.67a.51.51,0,0,0,0,.48L81,238a.47.47,0,0,0,.09.12.9.9,0,0,0,1.44,0,4.85,4.85,0,0,1,1.35-1.46.55.55,0,0,1,.74.24,21.779,21.779,0,0,1,1.17,2.78.54.54,0,0,1-.32.66,15.54,15.54,0,0,1-3.28,1,.55.55,0,0,1-.52-.22c-.52-.72-2-2.72-2.5-3.22a1.78,1.78,0,0,0-1.72-.18.56.56,0,0,1-.44-.06,1.19,1.19,0,0,1-.45-1.83.56.56,0,0,0-.17-.74,1.21,1.21,0,0,1-.47-1.72,1.71,1.71,0,0,1,1.85-.9.55.55,0,0,0,.59-.34.38.38,0,0,1,.29-.22.54.54,0,0,0,.43-.62,1.4,1.4,0,0,1,.78-1.61c1.48-.81,2.77.52,3.1,1.63s-1.32,1.91-2.36,2.05C79.84,233.4,79.42,234.24,79.26,234.67Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_182"
                    data-name="Path 182"
                    d="M79.82,238.89s-.66-1.92-1.5-1.85-1.51.91-.46,1.85C79.16,240.06,79.82,238.89,79.82,238.89Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_183"
                    data-name="Path 183"
                    d="M72.72,254.3a17.19,17.19,0,0,1-.7-6.74h.31a16.71,16.71,0,0,0,.68,6.6Z"
                    opacity="0.5"
                />
                <circle
                    id="Ellipse_5"
                    data-name="Ellipse 5"
                    cx="12.48"
                    cy="12.48"
                    r="12.48"
                    transform="translate(149.58 308.27)"
                    fill="#5b5b5b"
                />
                <circle
                    id="Ellipse_6"
                    data-name="Ellipse 6"
                    cx="10.85"
                    cy="10.85"
                    r="10.85"
                    transform="translate(151.23 310.01)"
                    fill="#fff"
                />
                <path
                    id="Path_184"
                    data-name="Path 184"
                    d="M172.15,328.14l-13.32-13.32-1.4,1.29,12.12,14.41.08.09.43.47c.74.8,1.77,1.05,2.31.56l.65-.59c.54-.5.38-1.55-.36-2.36l-.42-.46Zm-.25,2.34c-.35.33-1.1.1-1.65-.5s-.71-1.36-.35-1.69,1.1-.11,1.65.5S172.26,330.15,171.9,330.48Z"
                    fill="#717272"
                />
                <path
                    id="Path_185"
                    data-name="Path 185"
                    d="M155.2,309.44l2.48,2.71a.83.83,0,0,1,.21.72l-.23,1.32a.84.84,0,0,1-.76.7l-1.33.11a.81.81,0,0,1-.7-.27L152.38,312a.65.65,0,0,0-1.12.36,4.85,4.85,0,0,0,1.27,3.79,4.61,4.61,0,0,0,6.79-6.23,4.84,4.84,0,0,0-3.67-1.59.65.65,0,0,0-.45,1.11Z"
                    fill="#717272"
                />
                <path
                    id="Path_186"
                    data-name="Path 186"
                    d="M154.94,309.67l2.49,2.72a.83.83,0,0,1,.21.71l-.23,1.32a.85.85,0,0,1-.76.7l-1.34.12a.88.88,0,0,1-.7-.27l-2.48-2.72a.65.65,0,0,0-1.13.37,4.85,4.85,0,0,0,1.27,3.79,4.611,4.611,0,1,0,6.8-6.23,4.88,4.88,0,0,0-3.67-1.6.65.65,0,0,0-.46,1.09Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_187"
                    data-name="Path 187"
                    d="M171.94,328.32,158.63,315l-1.4,1.29,12.12,14.41.08.09.43.47c.73.8,1.77,1.05,2.31.55l.64-.59c.54-.49.39-1.55-.35-2.35l-.43-.47Zm-.24,2.34c-.36.33-1.1.11-1.65-.49s-.72-1.36-.36-1.69,1.1-.11,1.66.5S172.06,330.34,171.7,330.66Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_188"
                    data-name="Path 188"
                    d="M159.49,322.78l.97.85,8.83-10.33-.77-.67Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_189"
                    data-name="Path 189"
                    d="M161.45,320l1.47,1.28a.67.67,0,0,1,.08.93l-7.44,9.11a1.58,1.58,0,0,1-2.25.19l-.69-.61a1.56,1.56,0,0,1-.12-2.25l8-8.61A.68.68,0,0,1,161.45,320Z"
                    fill="#5b5b5b"
                />
                <rect
                    id="Rectangle_11"
                    data-name="Rectangle 11"
                    width="0.49"
                    height="12.26"
                    transform="matrix(-0.754, -0.657, 0.657, -0.754, 154.46, 331.198)"
                    fill="#717272"
                />
                <rect
                    id="Rectangle_12"
                    data-name="Rectangle 12"
                    width="0.49"
                    height="12.26"
                    transform="matrix(-0.754, -0.657, 0.657, -0.754, 153.767, 330.603)"
                    fill="#717272"
                />
                <rect
                    id="Rectangle_13"
                    data-name="Rectangle 13"
                    width="0.49"
                    height="12.26"
                    transform="matrix(-0.754, -0.657, 0.657, -0.754, 153.119, 330.017)"
                    fill="#717272"
                />
                <path
                    id="Path_190"
                    data-name="Path 190"
                    d="M171.61,309.37l.49.42a.35.35,0,0,1,.11.41l-.86,1.7a.27.27,0,0,1-.07.08l-1.94,1.49a.35.35,0,0,1-.43-.05l-.51-.45a.35.35,0,0,1-.1-.42l1.26-2.08a.16.16,0,0,1,.07-.07l1.57-1.09a.34.34,0,0,1,.41.06Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_191"
                    data-name="Path 191"
                    d="M264.89,165.24h0a3.52,3.52,0,0,0-3.5,3.29q-.21,3.18-.34,6.36a3.39,3.39,0,0,0,3.41,3.53h0a64.79,64.79,0,1,1-53,27.51c-3.67-2.22-7.27-4.59-11-6.67a78.08,78.08,0,1,0,64.46-34Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_192"
                    data-name="Path 192"
                    d="M189.42,198.84c5.3-2.16,21.44-8,24.53-9.16a.41.41,0,0,1,.55.36l1.38,27.49a3.61,3.61,0,0,1-1.34,3l-6.27,5a.41.41,0,0,1-.65-.22L202.8,205.9a.4.4,0,0,0-.56-.27l-14.79,6.58a1.49,1.49,0,0,1-2-1.83l3.76-11.29A.43.43,0,0,1,189.42,198.84Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_193"
                    data-name="Path 193"
                    d="M265,318.6a75.376,75.376,0,0,1-40.205-11.61.31.31,0,0,1-.075-.41.29.29,0,0,1,.41-.09,74.82,74.82,0,0,0,93.55-11.17.3.3,0,0,1,.43,0,.29.29,0,0,1,0,.42A75.27,75.27,0,0,1,265,318.6Z"
                    fill="#717272"
                />
                <path
                    id="Path_194"
                    data-name="Path 194"
                    d="M323.06,291.21a.28.28,0,0,1-.19-.07.29.29,0,0,1,0-.42,75.681,75.681,0,0,0,6.54-9.28.3.3,0,1,1,.52.3,75.18,75.18,0,0,1-6.6,9.36A.3.3,0,0,1,323.06,291.21Z"
                    fill="#717272"
                />
                <path
                    id="Path_195"
                    data-name="Path 195"
                    d="M331,279.52h-.15a.31.31,0,0,1-.12-.41,76.336,76.336,0,0,0,3.91-8.29.3.3,0,1,1,.56.22,76.708,76.708,0,0,1-3.94,8.36A.29.29,0,0,1,331,279.52Z"
                    fill="#717272"
                />
                <path
                    id="Path_196"
                    data-name="Path 196"
                    d="M190.22,200.24a.29.29,0,0,1-.28-.2.3.3,0,0,1,.17-.38l21.48-7.85a.3.3,0,1,1,.2.56l-21.47,7.85A.18.18,0,0,1,190.22,200.24Z"
                    fill="#717272"
                />
                <path
                    id="Path_197"
                    data-name="Path 197"
                    d="M206.79,264a.66.66,0,0,1-.63-.47c-.1-.34-.19-.68-.28-1a.651.651,0,0,1,1.26-.33c.09.33.18.66.28,1a.67.67,0,0,1-.45.82Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_198"
                    data-name="Path 198"
                    d="M205.79,259.56a.64.64,0,0,1-.64-.55c-.12-.71-.21-1.43-.29-2.15a.67.67,0,0,1,.59-.72.65.65,0,0,1,.71.59c.07.69.17,1.39.28,2.08a.67.67,0,0,1-.54.75Zm-.46-5.57a.66.66,0,0,1-.66-.65v-.24c0-.64,0-1.29.05-1.93a.66.66,0,0,1,1.31.06c0,.63-.05,1.25-.05,1.87v.23a.66.66,0,0,1-.65.66Zm.39-5.59h-.1a.66.66,0,0,1-.55-.74c.1-.72.23-1.44.38-2.14a.65.65,0,0,1,.77-.51.66.66,0,0,1,.51.77c-.14.68-.27,1.38-.37,2.06a.65.65,0,0,1-.64.56ZM207,243a.63.63,0,0,1-.19,0,.65.65,0,0,1-.43-.82c.21-.69.44-1.38.7-2.06a.66.66,0,0,1,.84-.38.65.65,0,0,1,.38.84c-.24.66-.47,1.32-.68,2a.64.64,0,0,1-.62.42Zm2.06-5.21a.75.75,0,0,1-.29-.06.66.66,0,0,1-.3-.88c.32-.64.66-1.29,1-1.92a.64.64,0,0,1,.89-.25.65.65,0,0,1,.24.89c-.34.61-.67,1.23-1,1.86a.66.66,0,0,1-.6.31Zm2.84-4.82a.63.63,0,0,1-.37-.12.65.65,0,0,1-.16-.91c.41-.59.85-1.18,1.29-1.74a.65.65,0,0,1,.92-.11.66.66,0,0,1,.11.92c-.43.54-.85,1.11-1.25,1.68a.66.66,0,0,1-.59.23Zm3.55-4.33a.64.64,0,0,1-.45-.18.66.66,0,0,1,0-.93c.5-.52,1-1,1.54-1.52a.66.66,0,0,1,.93,0,.65.65,0,0,1,0,.92c-.51.48-1,1-1.49,1.48a.67.67,0,0,1-.58.18Zm4.17-3.74a.67.67,0,0,1-.52-.25.65.65,0,0,1,.12-.92c.57-.44,1.16-.87,1.76-1.27a.652.652,0,0,1,.73,1.08c-.57.39-1.14.8-1.7,1.23a.65.65,0,0,1-.44.08Zm4.68-3.06a.65.65,0,0,1-.31-1.22c.63-.35,1.28-.68,1.93-1a.66.66,0,0,1,.87.31.64.64,0,0,1-.31.87,17.57,17.57,0,0,0-1.86,1,.61.61,0,0,1-.37-.01Zm34.32-.31a.67.67,0,0,1-.3-.08c-.62-.32-1.25-.63-1.88-.92a.651.651,0,0,1,.53-1.19c.66.3,1.32.62,2,1a.66.66,0,0,1-.31,1.24Zm-29.22-2a.66.66,0,0,1-.62-.43.67.67,0,0,1,.4-.84c.67-.24,1.37-.47,2.06-.67a.64.64,0,0,1,.81.44.66.66,0,0,1-.44.81c-.67.2-1.33.42-2,.65a.57.57,0,0,1-.26,0Zm24.08-.22h-.21c-.66-.23-1.34-.44-2-.62a.654.654,0,0,1,.35-1.26c.7.19,1.39.41,2.08.64a.65.65,0,0,1-.21,1.27ZM234.74,218a.65.65,0,0,1-.13-1.29c.71-.14,1.43-.26,2.15-.35a.651.651,0,1,1,.17,1.29c-.69.09-1.38.21-2.07.34Zm13.26-.11h-.11c-.68-.12-1.38-.22-2.07-.3a.67.67,0,0,1-.58-.73.65.65,0,0,1,.73-.57c.71.08,1.44.18,2.15.31a.65.65,0,0,1,.53.75.66.66,0,0,1-.65.54Zm-7.7-.53a.64.64,0,0,1-.65-.63.63.63,0,0,1,.62-.67h2.18a.66.66,0,0,1,.64.67.65.65,0,0,1-.67.63h-2.1Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_199"
                    data-name="Path 199"
                    d="M262.45,223.83a.63.63,0,0,1-.37-.12l-.85-.57a.655.655,0,1,1,.71-1.1l.88.6a.651.651,0,0,1-.37,1.19Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_200"
                    data-name="Path 200"
                    d="M277.55,247.49a.65.65,0,0,1-.64-.55c-.06-.33-.12-.67-.19-1a.67.67,0,0,1,.51-.78.66.66,0,0,1,.77.52c.07.34.14.69.2,1a.66.66,0,0,1-.54.76Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_201"
                    data-name="Path 201"
                    d="M241.06,290.09h0a15.1,15.1,0,0,1-1.9-.08h-.23a.652.652,0,1,1,.1-1.3h.22c.61,0,1.23.07,1.84.08a.65.65,0,1,1-.03,1.3Zm3.41-.1a.65.65,0,1,1,0-1.3c.68-.05,1.37-.12,2-.22a.67.67,0,0,1,.73.57.65.65,0,0,1-.56.73c-.7.09-1.42.17-2.13.22Zm-8.89-.41h-.11c-.7-.12-1.41-.26-2.1-.42a.652.652,0,0,1,.3-1.27c.66.15,1.34.29,2,.4a.66.66,0,0,1-.11,1.3Zm14.34-.41a.66.66,0,0,1-.64-.51.65.65,0,0,1,.49-.78c.67-.16,1.34-.34,2-.53a.66.66,0,0,1,.36,1.26c-.68.2-1.37.38-2.06.54Zm-19.69-.92a.509.509,0,0,1-.2,0c-.68-.22-1.35-.46-2-.73a.651.651,0,1,1,.48-1.21c.64.25,1.29.49,1.94.7a.66.66,0,0,1-.21,1.28Zm24.94-.73a.65.65,0,0,1-.24-1.26c.64-.26,1.27-.53,1.89-.82a.651.651,0,1,1,.55,1.18c-.64.3-1.3.59-2,.85a.74.74,0,0,1-.2.05Zm-30-1.4a.59.59,0,0,1-.29-.07c-.64-.32-1.27-.67-1.88-1a.654.654,0,1,1,.66-1.13c.59.35,1.2.68,1.81,1a.65.65,0,0,1-.3,1.23Zm35-1a.66.66,0,0,1-.34-1.22c.6-.35,1.18-.72,1.75-1.1a.66.66,0,1,1,.73,1.09c-.59.39-1.2.78-1.81,1.14a.68.68,0,0,1-.38.07Zm4.52-3.15a.65.65,0,0,1-.41-1.16c.53-.43,1-.88,1.56-1.34a.65.65,0,0,1,.92,0,.64.64,0,0,1,0,.92c-.52.48-1.07.95-1.62,1.4a.64.64,0,0,1-.5.21Zm4-3.78a.67.67,0,0,1-.44-.17.64.64,0,0,1,0-.92c.46-.51.91-1,1.34-1.57a.65.65,0,0,1,1,.82c-.45.56-.92,1.1-1.4,1.63a.64.64,0,0,1-.55.19Zm3.39-4.34a.72.72,0,0,1-.37-.11.66.66,0,0,1-.18-.91c.38-.57.75-1.16,1.09-1.75a.654.654,0,0,1,1.13.66c-.36.61-.74,1.22-1.13,1.81a.66.66,0,0,1-.62.28Zm2.69-4.81a.71.71,0,0,1-.28-.06.65.65,0,0,1-.31-.87c.28-.62.56-1.26.81-1.9a.66.66,0,0,1,1.22.48c-.27.66-.55,1.33-.85,2a.65.65,0,0,1-.64.31Zm1.93-5.16a.57.57,0,0,1-.18,0A.65.65,0,0,1,276,263c.19-.65.36-1.33.52-2a.65.65,0,0,1,.78-.5.66.66,0,0,1,.49.79c-.16.69-.34,1.38-.53,2.07a.67.67,0,0,1-.61.5Zm1.12-5.39h-.08a.65.65,0,0,1-.57-.73c.09-.68.16-1.37.21-2.05a.66.66,0,0,1,.7-.61.67.67,0,0,1,.61.7c-.06.71-.13,1.43-.22,2.13a.65.65,0,0,1-.7.54Zm.31-5.5a.66.66,0,0,1-.66-.64,14.149,14.149,0,0,0-.1-2.06.66.66,0,0,1,.61-.7.65.65,0,0,1,.7.6c.05.71.09,1.42.1,2.13a.66.66,0,0,1-.64.67Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_202"
                    data-name="Path 202"
                    d="M220.43,283.23a.68.68,0,0,1-.38-.12l-.85-.63a.65.65,0,0,1-.12-.92.64.64,0,0,1,.91-.12l.83.61a.64.64,0,0,1,.14.91.62.62,0,0,1-.53.27Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_203"
                    data-name="Path 203"
                    d="M222.06,272.94a.43.43,0,0,0,.49.13l5-1.83a23.1,23.1,0,0,0,6.6,3.56l1.22,5.17a.43.43,0,0,0,.38.33l6.34.64a.44.44,0,0,0,.44-.25l2.23-4.82a23.17,23.17,0,0,0,7.18-2.16l4.52,2.8a.42.42,0,0,0,.5,0l4.94-4a.42.42,0,0,0,.1-.51l-1.84-5a23.12,23.12,0,0,0,3.56-6.6l5.17-1.22a.44.44,0,0,0,.33-.38l.64-6.34a.42.42,0,0,0-.25-.44l-4.82-2.23a23.09,23.09,0,0,0-2.16-7.18l2.8-4.52a.44.44,0,0,0,0-.51l-4-4.94a.44.44,0,0,0-.49-.13l-5,1.83a23.339,23.339,0,0,0-6.6-3.55l-1.22-5.17a.44.44,0,0,0-.38-.34l-6.34-.64a.43.43,0,0,0-.44.25l-2.23,4.82a23.17,23.17,0,0,0-7.18,2.16L227,229a.45.45,0,0,0-.51,0l-4.93,4a.44.44,0,0,0-.14.49l1.84,5a23,23,0,0,0-3.56,6.61l-5.17,1.21a.44.44,0,0,0-.33.39l-.65,6.34a.45.45,0,0,0,.25.44l4.82,2.23a23.441,23.441,0,0,0,2.16,7.18L218,267.5a.42.42,0,0,0,0,.5Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_204"
                    data-name="Path 204"
                    d="M241.72,259a6.18,6.18,0,0,1-4.95-9.87,6.1,6.1,0,0,1,4.06-2.43,6.181,6.181,0,0,1,1.8,12.23A5.582,5.582,0,0,1,241.72,259Zm0-11.32a6.3,6.3,0,0,0-.75.05,5.142,5.142,0,1,0,.75-.05Z"
                    fill="#717272"
                />
                <path
                    id="Path_205"
                    data-name="Path 205"
                    d="M241.84,268.33a14.109,14.109,0,0,1-1.588-.09,16.588,16.588,0,0,1-2.342-.41h-.41l-.31-.09-.18-.06a.26.26,0,0,1-.18-.25.25.25,0,0,1,0-.08.27.27,0,0,1,.33-.17,14.711,14.711,0,0,0,3.15.66,15.1,15.1,0,0,0,16.57-13.51c.05-.52.08-1,.08-1.54a15.12,15.12,0,0,0-30.17-1.51c-.05.51-.07,1-.07,1.53a15.1,15.1,0,0,0,1.42,6.41.2.2,0,0,1,0,.11.28.28,0,0,1-.15.24.27.27,0,0,1-.35-.13,15.65,15.65,0,0,1-1.48-6.63,10.391,10.391,0,0,1,.08-1.58,15.64,15.64,0,0,1,31.21,1.56,10.724,10.724,0,0,1-.08,1.59A15.67,15.67,0,0,1,241.84,268.33Z"
                    fill="#717272"
                />
                <path
                    id="Path_206"
                    data-name="Path 206"
                    d="M279.36,221.19l2.71-1.24a13.25,13.25,0,0,0,3.84,1.69l.91,2.83a.24.24,0,0,0,.23.17l3.57.08a.24.24,0,0,0,.23-.16l1-2.79a13.07,13.07,0,0,0,3.92-1.53l2.65,1.36a.24.24,0,0,0,.28,0l2.58-2.47a.26.26,0,0,0,.05-.28l-1.24-2.7a13.31,13.31,0,0,0,1.69-3.85l2.83-.91a.23.23,0,0,0,.17-.22l.08-3.57a.25.25,0,0,0-.16-.24l-2.79-1a12.911,12.911,0,0,0-1.53-3.91l1.36-2.65a.24.24,0,0,0,0-.28l-2.47-2.58a.24.24,0,0,0-.28-.06l-2.7,1.25a12.791,12.791,0,0,0-3.85-1.69l-.91-2.84a.25.25,0,0,0-.22-.17l-3.57-.07a.24.24,0,0,0-.24.16l-1,2.79a12.89,12.89,0,0,0-3.91,1.52l-2.65-1.36a.24.24,0,0,0-.28,0L277,198.91a.25.25,0,0,0-.06.28l1.25,2.71a12.729,12.729,0,0,0-1.69,3.84l-2.84.91a.25.25,0,0,0-.17.23l-.07,3.57a.23.23,0,0,0,.16.23l2.79,1a13,13,0,0,0,1.52,3.92l-1.36,2.65a.24.24,0,0,0,0,.28l2.47,2.58a.26.26,0,0,0,.36.08Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_207"
                    data-name="Path 207"
                    d="M289.17,212.44a3.41,3.41,0,1,1,3.209-2.287,3.44,3.44,0,0,1-3.209,2.287Zm0-6.35a3,3,0,0,0-.65.08,2.874,2.874,0,1,0,.65-.08Z"
                    fill="#717272"
                />
                <g id="Group_10" data-name="Group 10" opacity="0.64">
                    <path
                        id="Path_208"
                        data-name="Path 208"
                        d="M273.16,220.15a.64.64,0,0,1-.55-.29c-.2-.3-.39-.61-.57-.92a.65.65,0,0,1,.24-.89.64.64,0,0,1,.89.23c.17.29.35.58.53.86a.65.65,0,0,1-.19.91.64.64,0,0,1-.35.1Z"
                        fill="#e3e2e2"
                    />
                    <path
                        id="Path_209"
                        data-name="Path 209"
                        d="M271.23,216.34a.63.63,0,0,1-.61-.43,19.372,19.372,0,0,1-.62-2,.66.66,0,0,1,1.27-.33c.16.62.35,1.24.57,1.84a.65.65,0,0,1-.61.88Zm-1.14-5.09a.65.65,0,0,1-.65-.6c-.05-.55-.07-1.11-.07-1.66v-.39a.66.66,0,0,1,1.31,0v.4a13.738,13.738,0,0,0,.06,1.55.65.65,0,0,1-.59.71Zm.28-5.2h-.13a.67.67,0,0,1-.52-.77,20.152,20.152,0,0,1,.5-2,.653.653,0,1,1,1.25.38,17,17,0,0,0-.46,1.87A.66.66,0,0,1,270.37,206.05Zm1.67-4.94a.59.59,0,0,1-.29-.07.64.64,0,0,1-.3-.87,18.42,18.42,0,0,1,1-1.79.65.65,0,0,1,.9-.21.67.67,0,0,1,.2.91c-.34.54-.66,1.1-.95,1.67a.64.64,0,0,1-.6.36Zm2.94-4.3a.66.66,0,0,1-.49-1.09,20.1,20.1,0,0,1,1.46-1.46.663.663,0,0,1,.87,1c-.47.43-.93.89-1.36,1.36a.66.66,0,0,1-.46.19Zm4-3.36a.65.65,0,0,1-.34-1.2,17.483,17.483,0,0,1,1.79-1,.66.66,0,0,1,.88.3.65.65,0,0,1-.3.87c-.57.29-1.14.6-1.68.94a.64.64,0,0,1-.33.09Zm4.75-2.14a.65.65,0,0,1-.62-.47.64.64,0,0,1,.44-.81c.39-.12.8-.23,1.21-.32l.79-.17a.66.66,0,0,1,.24,1.29,3.242,3.242,0,0,0-.74.15c-.25.06-.76.19-1.13.3a.63.63,0,0,1-.21.03Zm7.14-.73h-.06a17.509,17.509,0,0,0-1.92-.07.64.64,0,0,1-.66-.64.66.66,0,0,1,.64-.67,20.146,20.146,0,0,1,2.06.08.64.64,0,0,1,.59.7.65.65,0,0,1-.67.6Z"
                        fill="#e3e2e2"
                    />
                    <path
                        id="Path_210"
                        data-name="Path 210"
                        d="M295.05,191.43a.69.69,0,0,1-.2,0c-.32-.1-.65-.2-1-.28a.65.65,0,0,1-.46-.8.66.66,0,0,1,.8-.47c.34.09.69.2,1,.31a.65.65,0,0,1-.2,1.27Z"
                        fill="#e3e2e2"
                    />
                </g>
                <g id="Group_11" data-name="Group 11" opacity="0.64">
                    <path
                        id="Path_211"
                        data-name="Path 211"
                        d="M306.49,201.48a.66.66,0,0,1-.59-.37c-.14-.31-.3-.61-.46-.9a.66.66,0,0,1,.27-.89.65.65,0,0,1,.88.27,10.341,10.341,0,0,1,.49,1,.66.66,0,0,1-.31.87A.71.71,0,0,1,306.49,201.48Z"
                        fill="#e3e2e2"
                    />
                    <path
                        id="Path_212"
                        data-name="Path 212"
                        d="M289.16,228.81a21.1,21.1,0,0,1-2.26-.13.67.67,0,0,1-.58-.73.65.65,0,0,1,.73-.57,18.517,18.517,0,0,0,2.11.12h0a.65.65,0,0,1,.66.65.66.66,0,0,1-.66.66Zm3.6-.35a.66.66,0,0,1-.64-.53.65.65,0,0,1,.52-.76l.67-.14c.47-.11.95-.24,1.41-.39a.655.655,0,0,1,.39,1.25c-.49.16-1,.29-1.51.41l-.71.15Zm5.47-1.93a.68.68,0,0,1-.58-.34.66.66,0,0,1,.27-.89,17.751,17.751,0,0,0,1.82-1.12.66.66,0,0,1,.91.16.65.65,0,0,1-.16.91,19.628,19.628,0,0,1-1.95,1.2.71.71,0,0,1-.31.08Zm4.63-3.48a.63.63,0,0,1-.46-.19.65.65,0,0,1,0-.92,16.593,16.593,0,0,0,1.4-1.62.66.66,0,0,1,.92-.11.64.64,0,0,1,.12.91,20.655,20.655,0,0,1-1.5,1.73.67.67,0,0,1-.48.2Zm3.38-4.71a.63.63,0,0,1-.3-.07.66.66,0,0,1-.29-.88,15.529,15.529,0,0,0,.86-2,.655.655,0,1,1,1.23.45,21.872,21.872,0,0,1-.92,2.1.66.66,0,0,1-.58.4Zm1.82-5.5H308a.66.66,0,0,1-.54-.76,18.843,18.843,0,0,0,.24-2.12.64.64,0,0,1,.68-.62.65.65,0,0,1,.62.68,19.387,19.387,0,0,1-.25,2.28.65.65,0,0,1-.69.54Zm.08-5.8a.66.66,0,0,1-.65-.56c-.07-.54-.17-1.08-.29-1.61l-.12-.49a.651.651,0,1,1,1.26-.33c.05.17.09.35.13.52.13.57.24,1.15.32,1.73a.65.65,0,0,1-.56.73Z"
                        fill="#e3e2e2"
                    />
                    <path
                        id="Path_213"
                        data-name="Path 213"
                        d="M283.44,227.93a.63.63,0,0,1-.19,0l-1-.35a.66.66,0,1,1,.46-1.23c.31.12.63.23.95.33a.65.65,0,0,1-.2,1.28Z"
                        fill="#e3e2e2"
                    />
                </g>
                <path
                    id="Path_214"
                    data-name="Path 214"
                    d="M289.18,217.88H289a9,9,0,0,1-1.87-.24.27.27,0,0,1-.21-.25s0,0,0-.07a.27.27,0,0,1,.32-.19,8.661,8.661,0,0,0,1.76.23,8.37,8.37,0,0,0,8.54-8.18V209a8.36,8.36,0,0,0-16.71-.18V209a8.32,8.32,0,0,0,1.09,4.14.279.279,0,0,1,0,.13.23.23,0,0,1-.13.22.26.26,0,0,1-.35-.09,8.81,8.81,0,0,1-1.17-4.4,1.274,1.274,0,0,1,0-.19,8.88,8.88,0,0,1,17.75.19v.19a8.87,8.87,0,0,1-8.87,8.69Z"
                    fill="#717272"
                />
                <path
                    id="Path_215"
                    data-name="Path 215"
                    d="M280.21,259.77a.66.66,0,0,1-.63-.47c-.1-.34-.19-.68-.28-1a.66.66,0,0,1,.48-.79.64.64,0,0,1,.79.47q.12.49.27,1a.66.66,0,0,1-.44.81A.65.65,0,0,1,280.21,259.77Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_216"
                    data-name="Path 216"
                    d="M279.36,255.44a.65.65,0,0,1-.65-.58c-.07-.71-.12-1.42-.13-2.13a.66.66,0,1,1,1.31,0,18.838,18.838,0,0,0,.12,2,.65.65,0,0,1-.58.72Zm.05-5.44h-.08a.65.65,0,0,1-.57-.73c.08-.7.2-1.41.34-2.1a.654.654,0,0,1,1.28.27c-.14.65-.24,1.32-.32,2a.66.66,0,0,1-.65.56Zm1.24-5.29a.57.57,0,0,1-.22,0,.65.65,0,0,1-.4-.83q.36-1,.81-2a.65.65,0,0,1,.86-.32.66.66,0,0,1,.33.87c-.28.61-.54,1.23-.76,1.87a.67.67,0,0,1-.62.41Zm2.39-4.88a.66.66,0,0,1-.55-1q.58-.9,1.23-1.74a.64.64,0,0,1,.91-.13.65.65,0,0,1,.12.92c-.4.53-.79,1.09-1.15,1.65a.67.67,0,0,1-.6.3Zm3.43-4.23a.67.67,0,0,1-.47-.2.65.65,0,0,1,0-.92,14.357,14.357,0,0,1,1.58-1.43.65.65,0,1,1,.83,1c-.51.43-1,.89-1.49,1.36a.7.7,0,0,1-.45.19Zm4.27-3.37a.65.65,0,0,1-.35-1.21c.6-.37,1.23-.73,1.86-1.05a.66.66,0,0,1,.59,1.17c-.6.3-1.19.64-1.76,1a.63.63,0,0,1-.34.09Zm22.88-1.51a.63.63,0,0,1-.27-.06c-.61-.27-1.24-.53-1.88-.75a.65.65,0,0,1-.4-.83.66.66,0,0,1,.84-.4c.67.23,1.33.5,2,.79a.66.66,0,0,1,.32.87.64.64,0,0,1-.61.38Zm-18-.83a.64.64,0,0,1-.61-.44.65.65,0,0,1,.4-.83c.67-.23,1.36-.44,2-.61a.64.64,0,0,1,.79.47.66.66,0,0,1-.47.8c-.65.16-1.3.36-1.93.57a.571.571,0,0,1-.16.04Zm12.8-.84h-.13c-.66-.13-1.33-.24-2-.32a.65.65,0,0,1-.57-.72.64.64,0,0,1,.72-.57c.71.08,1.42.19,2.11.33a.65.65,0,0,1-.13,1.29ZM301,228.7a.651.651,0,0,1-.07-1.3c.7-.07,1.42-.12,2.13-.14h0a.66.66,0,0,1,0,1.31,18.829,18.829,0,0,0-2,.13Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_217"
                    data-name="Path 217"
                    d="M317.47,232.91a.63.63,0,0,1-.37-.12c-.28-.19-.56-.38-.85-.56a.65.65,0,0,1-.2-.9.64.64,0,0,1,.9-.2l.89.59a.65.65,0,0,1-.37,1.19Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_218"
                    data-name="Path 218"
                    d="M327.64,249.09a.66.66,0,0,1-.65-.55c-.05-.34-.11-.68-.18-1a.653.653,0,0,1,1.28-.26c.07.35.14.71.19,1.06a.66.66,0,0,1-.54.75Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_219"
                    data-name="Path 219"
                    d="M303.62,277.27h-.86a.65.65,0,0,1,0-1.3h2.01a.65.65,0,0,1,.68.62.66.66,0,0,1-.62.69C304.45,277.26,304,277.27,303.62,277.27Zm-4.13-.35h-.11c-.69-.11-1.38-.26-2.06-.43a.66.66,0,1,1,.33-1.27c.64.16,1.29.3,1.94.41a.652.652,0,0,1-.1,1.3Zm8.63-.07a.66.66,0,0,1-.12-1.3c.65-.12,1.3-.27,1.94-.45a.654.654,0,1,1,.35,1.26c-.68.19-1.36.35-2.05.48Zm-13.78-1.4a.7.7,0,0,1-.25-.05c-.64-.26-1.29-.56-1.91-.88a.653.653,0,0,1,.6-1.16c.59.3,1.19.58,1.81.83a.66.66,0,0,1,.35.86.65.65,0,0,1-.6.4Zm18.89-.17A.66.66,0,0,1,313,274c.6-.26,1.2-.55,1.78-.86a.66.66,0,0,1,.89.27.65.65,0,0,1-.27.88c-.61.33-1.25.64-1.89.91a.58.58,0,0,1-.28.08Zm4.65-2.65a.68.68,0,0,1-.53-.27.65.65,0,0,1,.15-.91c.53-.39,1.06-.81,1.56-1.24a.656.656,0,0,1,.85,1c-.53.46-1.08.89-1.64,1.3a.63.63,0,0,1-.39.12Zm4-3.6a.66.66,0,0,1-.49-1.09c.44-.49.86-1,1.26-1.54a.65.65,0,0,1,1,.78c-.41.56-.86,1.11-1.32,1.63a.68.68,0,0,1-.49.19Zm3.08-4.38a.6.6,0,0,1-.31-.08.66.66,0,0,1-.26-.89c.32-.57.62-1.17.89-1.78a.653.653,0,1,1,1.19.54c-.28.63-.6,1.26-.93,1.87a.65.65,0,0,1-.62.34Zm2.05-4.94h-.18a.65.65,0,0,1-.44-.81c.18-.63.34-1.28.47-1.93a.653.653,0,1,1,1.28.26c-.14.68-.31,1.37-.5,2a.65.65,0,0,1-.64.48Zm.92-5.28h0a.66.66,0,0,1-.62-.69v-1.99a.65.65,0,0,1,.64-.67h0a.65.65,0,0,1,.65.64v2.1a.65.65,0,0,1-.71.61Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_220"
                    data-name="Path 220"
                    d="M289.63,272.88a.68.68,0,0,1-.38-.12c-.29-.21-.58-.42-.86-.64a.65.65,0,1,1,.79-1l.82.6a.65.65,0,0,1-.37,1.19Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_221"
                    data-name="Path 221"
                    d="M290.43,265.57a.31.31,0,0,0,.33.09l3.34-1.23a15.7,15.7,0,0,0,4.42,2.38l.81,3.46a.29.29,0,0,0,.26.22l4.24.43a.28.28,0,0,0,.3-.16l1.49-3.23a15.43,15.43,0,0,0,4.81-1.45l3,1.88a.3.3,0,0,0,.34,0l3.31-2.69a.31.31,0,0,0,.09-.33L316,261.57a15.7,15.7,0,0,0,2.38-4.42l3.46-.81a.29.29,0,0,0,.22-.26l.43-4.24a.28.28,0,0,0-.17-.3l-3.22-1.49a15.51,15.51,0,0,0-1.45-4.81l1.87-3a.29.29,0,0,0,0-.34l-2.69-3.31a.32.32,0,0,0-.33-.09l-3.34,1.23a15.7,15.7,0,0,0-4.42-2.38l-.81-3.46a.3.3,0,0,0-.26-.22l-4.24-.43a.28.28,0,0,0-.3.17l-1.49,3.22a15.429,15.429,0,0,0-4.81,1.45l-3-1.87a.28.28,0,0,0-.34,0l-3.31,2.7a.3.3,0,0,0-.09.32l1.23,3.34a15.7,15.7,0,0,0-2.38,4.42l-3.46.82a.28.28,0,0,0-.22.25l-.43,4.25a.28.28,0,0,0,.16.29l3.23,1.49a15.431,15.431,0,0,0,1.45,4.81l-1.88,3a.3.3,0,0,0,0,.34Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_222"
                    data-name="Path 222"
                    d="M303.59,256.64a4.6,4.6,0,1,1,.68-.05A4,4,0,0,1,303.59,256.64Zm0-7.57h-.45A3,3,0,0,0,304,255h0a3,3,0,0,0-.47-5.97Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_223"
                    data-name="Path 223"
                    d="M303.67,262.57a9.732,9.732,0,0,1-1.07-.06h0a10.25,10.25,0,0,1-2.2-.46.27.27,0,0,1-.18-.25.22.22,0,0,1,0-.08.27.27,0,0,1,.33-.17,10,10,0,0,0,13.1-8.55c0-.34.05-.68.05-1a10.012,10.012,0,1,0-20-1c0,.34-.05.68-.05,1a10,10,0,0,0,.95,4.26.359.359,0,0,1,0,.11.24.24,0,0,1-.15.23.27.27,0,0,1-.35-.12,10.63,10.63,0,0,1-1-4.47,7.812,7.812,0,0,1,.05-1.08A10.56,10.56,0,0,1,314.22,252a7.745,7.745,0,0,1-.05,1.07A10.58,10.58,0,0,1,303.67,262.57Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_224"
                    data-name="Path 224"
                    d="M268.36,289.5a.64.64,0,0,1-.62-.47,10.3,10.3,0,0,1-.27-1.06.654.654,0,1,1,1.28-.27c.07.32.15.65.24,1a.65.65,0,0,1-.44.81Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_225"
                    data-name="Path 225"
                    d="M267.85,285.19h0a.66.66,0,0,1-.62-.69,2.645,2.645,0,0,1,0-.28,12.7,12.7,0,0,1,.25-1.84.64.64,0,0,1,.77-.5.65.65,0,0,1,.51.77,13,13,0,0,0-.23,1.66,2.253,2.253,0,0,0,0,.26A.66.66,0,0,1,267.85,285.19Zm1.33-5.15a.59.59,0,0,1-.29-.07.65.65,0,0,1-.3-.87,14.2,14.2,0,0,1,1.1-1.84.653.653,0,1,1,1.07.75,11.293,11.293,0,0,0-1,1.67.66.66,0,0,1-.58.32Zm3.27-4.19a.65.65,0,0,1-.42-1.15,14.066,14.066,0,0,1,1.73-1.25.653.653,0,1,1,.69,1.11,12.575,12.575,0,0,0-1.57,1.14.7.7,0,0,1-.43.15Zm4.67-2.54a.64.64,0,0,1-.62-.46.66.66,0,0,1,.43-.82,13.682,13.682,0,0,1,2.09-.46.66.66,0,1,1,.18,1.3,12.248,12.248,0,0,0-1.89.41.631.631,0,0,1-.19.03Zm7.3-.08h-.18a12.266,12.266,0,0,0-1.9-.37.66.66,0,0,1-.57-.73.64.64,0,0,1,.72-.57,13.442,13.442,0,0,1,2.1.41.66.66,0,0,1,.46.8.67.67,0,0,1-.63.46Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_226"
                    data-name="Path 226"
                    d="M288.36,275.08A.67.67,0,0,1,288,275c-.27-.19-.55-.37-.83-.54a.652.652,0,1,1,.65-1.13c.32.19.63.39.93.59a.65.65,0,0,1,.16.91.62.62,0,0,1-.55.25Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_227"
                    data-name="Path 227"
                    d="M293.88,284.24a.65.65,0,0,1-.65-.57,5.073,5.073,0,0,0-.16-1,.653.653,0,1,1,1.28-.26q.11.54.18,1.08a.66.66,0,0,1-.57.73Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_228"
                    data-name="Path 228"
                    d="M282,298.85a.66.66,0,0,1-.05-1.31,13.349,13.349,0,0,0,1.88-.29.65.65,0,0,1,.79.48.67.67,0,0,1-.49.79,13.236,13.236,0,0,1-2.08.32Zm-3.25-.15h-.11a14.494,14.494,0,0,1-2-.51.655.655,0,0,1,.42-1.24,11.787,11.787,0,0,0,1.84.46.652.652,0,0,1-.11,1.3Zm8.27-1.31a.65.65,0,0,1-.58-.35.66.66,0,0,1,.28-.88,11.728,11.728,0,0,0,1.61-1,.65.65,0,0,1,.91.14.64.64,0,0,1-.13.91,14.359,14.359,0,0,1-1.78,1.12.67.67,0,0,1-.33.06Zm4-3.3a.66.66,0,0,1-.5-1.07,12.823,12.823,0,0,0,1.09-1.56.65.65,0,0,1,.89-.23.64.64,0,0,1,.23.89,13.683,13.683,0,0,1-1.2,1.73.65.65,0,0,1-.53.24Zm2.44-4.63h-.18a.65.65,0,0,1-.45-.81,12.771,12.771,0,0,0,.38-1.86.656.656,0,0,1,1.3.17,13.229,13.229,0,0,1-.43,2.06.65.65,0,0,1-.62.44Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_229"
                    data-name="Path 229"
                    d="M273.82,296.8a.65.65,0,0,1-.36-.1c-.3-.2-.61-.42-.89-.64a.64.64,0,0,1-.13-.91.65.65,0,0,1,.92-.12q.39.3.81.57a.66.66,0,0,1,.2.9A.65.65,0,0,1,273.82,296.8Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_230"
                    data-name="Path 230"
                    d="M273.85,292.31a.14.14,0,0,0,.17,0l1.8-.65a8.31,8.31,0,0,0,2.37,1.27l.43,1.86a.17.17,0,0,0,.14.12l2.28.23a.15.15,0,0,0,.16-.09l.8-1.73a8.4,8.4,0,0,0,2.58-.78l1.62,1a.17.17,0,0,0,.18,0l1.78-1.45a.15.15,0,0,0,0-.18l-.66-1.79a8.229,8.229,0,0,0,1.28-2.37l1.86-.44a.16.16,0,0,0,.12-.13l.23-2.28a.15.15,0,0,0-.09-.16l-1.73-.8a8.4,8.4,0,0,0-.78-2.58l1-1.62a.17.17,0,0,0,0-.19L288,277.82a.17.17,0,0,0-.18-.05l-1.79.66a8.47,8.47,0,0,0-2.37-1.28l-.44-1.85a.14.14,0,0,0-.14-.12l-2.27-.23a.15.15,0,0,0-.16.09l-.8,1.73a8.379,8.379,0,0,0-2.58.77l-1.62-1a.17.17,0,0,0-.19,0L273.67,278a.16.16,0,0,0-.05.17l.66,1.8a8.34,8.34,0,0,0-1.28,2.37l-1.85.43a.15.15,0,0,0-.12.14l-.23,2.28a.15.15,0,0,0,.09.16l1.73.8a8.38,8.38,0,0,0,.77,2.58l-1,1.62a.15.15,0,0,0,0,.18Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_231"
                    data-name="Path 231"
                    d="M280.91,287.88a2.82,2.82,0,1,1,2.134-.977,2.82,2.82,0,0,1-2.134.977Zm0-4.07h-.19a1.24,1.24,0,1,0,.93.23,1.27,1.27,0,0,0-.73-.23Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_232"
                    data-name="Path 232"
                    d="M281,290.82h-.59l-.37-.05h0a2.175,2.175,0,0,1-.6-.14h-.21a.25.25,0,0,1-.18-.24.28.28,0,0,1,0-.09.26.26,0,0,1,.33-.16,5.647,5.647,0,0,0,1.1.23h0a5.28,5.28,0,0,0,5.76-4.63v-.08a4.9,4.9,0,0,0,0-.54,5.26,5.26,0,0,0-10.5-.52,4.835,4.835,0,0,0,0,.53,5.191,5.191,0,0,0,.5,2.23.26.26,0,0,1,0,.11.27.27,0,0,1-.15.24.26.26,0,0,1-.35-.12,5.81,5.81,0,0,1-.55-2.46,5.639,5.639,0,0,1,0-.58,5.78,5.78,0,1,1,5.76,6.37Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_233"
                    data-name="Path 233"
                    d="M247.85,221.71a.27.27,0,0,1-.25-.19c-.06-.21-.12-.43-.17-.65a.26.26,0,0,1,.2-.31.25.25,0,0,1,.31.2c.05.2.1.41.16.61a.27.27,0,0,1-.17.33Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_234"
                    data-name="Path 234"
                    d="M247.47,219.81a.26.26,0,0,1-.26-.23,11.666,11.666,0,0,1-.08-1.31.25.25,0,0,1,.26-.26h0a.26.26,0,0,1,.26.26,10.628,10.628,0,0,0,.08,1.25.27.27,0,0,1-.23.29Zm0-2.56h0a.26.26,0,0,1-.23-.29,9.508,9.508,0,0,1,.21-1.3.26.26,0,0,1,.31-.2.27.27,0,0,1,.2.32,10.175,10.175,0,0,0-.2,1.23.27.27,0,0,1-.3.24Zm.55-2.5h-.09a.27.27,0,0,1-.16-.33,11.587,11.587,0,0,1,.5-1.22.25.25,0,0,1,.34-.12.26.26,0,0,1,.13.35,9.072,9.072,0,0,0-.47,1.16.27.27,0,0,1-.27.16Zm1.1-2.32a.23.23,0,0,1-.14,0,.27.27,0,0,1-.09-.36,13.158,13.158,0,0,1,.76-1.08.263.263,0,1,1,.41.33,10.411,10.411,0,0,0-.72,1,.27.27,0,0,1-.23.11Zm1.58-2a.26.26,0,0,1-.18-.07.27.27,0,0,1,0-.37,10.133,10.133,0,0,1,1-.88.258.258,0,1,1,.37.36,10.772,10.772,0,0,0-.93.85.26.26,0,0,1-.27.09Zm2-1.61a.26.26,0,0,1-.22-.12.27.27,0,0,1,.08-.36,12.864,12.864,0,0,1,1.14-.65.26.26,0,0,1,.35.12.25.25,0,0,1-.11.35,11.917,11.917,0,0,0-1.1.62.23.23,0,0,1-.16.02Zm11.05-.73h-.11a11.715,11.715,0,0,0-1.16-.47.26.26,0,0,1-.17-.33.27.27,0,0,1,.34-.16,10.555,10.555,0,0,1,1.21.49.25.25,0,0,1,.13.34.26.26,0,0,1-.26.11Zm-8.75-.4a.263.263,0,0,1-.09-.51,13.1,13.1,0,0,1,1.26-.38.26.26,0,0,1,.31.2.25.25,0,0,1-.19.31c-.4.1-.81.22-1.2.36Zm6.32-.42h-.05a10.31,10.31,0,0,0-1.24-.19.27.27,0,0,1-.23-.29.25.25,0,0,1,.28-.23,11.334,11.334,0,0,1,1.3.2.26.26,0,0,1,.2.31.27.27,0,0,1-.28.18Zm-3.83-.18a.26.26,0,0,1-.26-.23.27.27,0,0,1,.23-.29,11.38,11.38,0,0,1,1.31-.08h0a.26.26,0,1,1,0,.52,10.355,10.355,0,0,0-1.25.08Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_235"
                    data-name="Path 235"
                    d="M265.42,209a.3.3,0,0,1-.15,0l-.53-.35a.27.27,0,0,1-.09-.36.26.26,0,0,1,.36-.08c.19.11.38.24.56.36a.27.27,0,0,1,.07.37.28.28,0,0,1-.22.06Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_236"
                    data-name="Path 236"
                    d="M270.24,216.83a.27.27,0,0,1-.26-.23,3.469,3.469,0,0,0-.11-.63.27.27,0,0,1,.21-.31.26.26,0,0,1,.3.21c.05.21.09.44.12.66a.26.26,0,0,1-.22.29Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_237"
                    data-name="Path 237"
                    d="M258.89,230h-.55a.26.26,0,0,1-.25-.27.28.28,0,0,1,.28-.25,10.08,10.08,0,0,0,1.23,0,.27.27,0,0,1,.28.25.26.26,0,0,1-.25.27Zm-1.79-.14h0c-.43-.07-.85-.16-1.27-.27a.26.26,0,0,1-.18-.32.27.27,0,0,1,.32-.19,10,10,0,0,0,1.21.26.27.27,0,0,1,.22.3.26.26,0,0,1-.3.18Zm3.77,0a.28.28,0,0,1-.26-.21.26.26,0,0,1,.22-.3c.4-.08.8-.17,1.2-.29a.26.26,0,0,1,.32.18.27.27,0,0,1-.18.33,10.776,10.776,0,0,1-1.25.29Zm-6.21-.62h-.09a10.451,10.451,0,0,1-1.18-.54.26.26,0,0,1-.1-.35.25.25,0,0,1,.35-.11,11.377,11.377,0,0,0,1.12.52.26.26,0,0,1-.1.5Zm8.63-.08a.25.25,0,0,1-.24-.17.26.26,0,0,1,.14-.34c.38-.16.75-.34,1.11-.53a.258.258,0,1,1,.25.45,11.349,11.349,0,0,1-1.16.57Zm2.21-1.23a.24.24,0,0,1-.22-.11.26.26,0,0,1,.07-.36,10.1,10.1,0,0,0,1-.77.27.27,0,0,1,.37,0,.26.26,0,0,1,0,.37c-.32.28-.66.55-1,.8a.28.28,0,0,1-.22-.01Zm1.88-1.67a.27.27,0,0,1-.17-.06.26.26,0,0,1,0-.37,11.7,11.7,0,0,0,.78-1,.261.261,0,1,1,.42.31,12.643,12.643,0,0,1-.81,1,.3.3,0,0,1-.22.04Zm1.48-2a.31.31,0,0,1-.13,0,.26.26,0,0,1-.09-.36c.2-.36.38-.73.55-1.1a.25.25,0,0,1,.34-.14.27.27,0,0,1,.14.34,11.412,11.412,0,0,1-.58,1.16.28.28,0,0,1-.23-.02Zm1-2.32h-.08a.26.26,0,0,1-.17-.32,10.462,10.462,0,0,0,.29-1.2.264.264,0,0,1,.52.09,12.865,12.865,0,0,1-.31,1.26.26.26,0,0,1-.25.05Zm.46-2.47h0a.27.27,0,0,1-.24-.28v-1.35a.27.27,0,0,1,.25-.27.26.26,0,0,1,.27.25v1.29a.26.26,0,0,1-.28.24Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_238"
                    data-name="Path 238"
                    d="M252.42,228a.24.24,0,0,1-.14,0c-.19-.12-.37-.26-.54-.39a.244.244,0,1,1,.31-.37l.52.37a.26.26,0,0,1,.07.36A.25.25,0,0,1,252.42,228Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_239"
                    data-name="Path 239"
                    d="M252.67,224.49a.16.16,0,0,0,.16,0l1.57-.58a7.13,7.13,0,0,0,2.09,1.12l.38,1.63a.14.14,0,0,0,.12.11l2,.2a.12.12,0,0,0,.14-.08l.7-1.52a7.289,7.289,0,0,0,2.27-.68l1.43.88a.14.14,0,0,0,.16,0l1.56-1.27a.14.14,0,0,0,0-.15l-.58-1.58a7.2,7.2,0,0,0,1.12-2.08l1.63-.39a.14.14,0,0,0,.11-.12l.2-2a.13.13,0,0,0-.08-.14l-1.52-.7a7.29,7.29,0,0,0-.68-2.27l.88-1.43a.14.14,0,0,0,0-.16l-1.27-1.55a.13.13,0,0,0-.15,0l-1.58.58a7.2,7.2,0,0,0-2.08-1.12l-.39-1.63a.14.14,0,0,0-.12-.11l-2-.2a.14.14,0,0,0-.14.08l-.7,1.52a7.29,7.29,0,0,0-2.27.68l-1.43-.88a.12.12,0,0,0-.15,0l-1.56,1.27a.14.14,0,0,0-.05.16l.58,1.57a7.13,7.13,0,0,0-1.12,2.09l-1.63.38a.14.14,0,0,0-.11.12l-.2,2a.13.13,0,0,0,.08.14l1.52.7a7.29,7.29,0,0,0,.68,2.27l-.88,1.43a.14.14,0,0,0,0,.16Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_240"
                    data-name="Path 240"
                    d="M258.88,220.17a2,2,0,1,1,.3,0Zm0-3.57h-.22a1.53,1.53,0,1,0,.44,3h0a1.52,1.52,0,0,0-.22-3Z"
                    fill="#717272"
                />
                <path
                    id="Path_241"
                    data-name="Path 241"
                    d="M258.92,223.21a4.412,4.412,0,0,1-.52,0h0a4.84,4.84,0,0,1-1.07-.22.27.27,0,0,1-.18-.25.22.22,0,0,1,0-.08.27.27,0,0,1,.33-.17,4.43,4.43,0,0,0,1,.2h0a4.59,4.59,0,0,0,5-4v-.12a3.589,3.589,0,0,0,0-.47,4.581,4.581,0,0,0-9.14-.45c0,.15,0,.31,0,.46a4.66,4.66,0,0,0,.43,1.95.23.23,0,0,1,0,.11.28.28,0,0,1-.15.24.27.27,0,0,1-.35-.13,5.08,5.08,0,0,1-.48-2.16,4.429,4.429,0,0,1,0-.52,5.12,5.12,0,0,1,10.21.5,4.71,4.71,0,0,1,0,.53,5.11,5.11,0,0,1-5.08,4.58Z"
                    fill="#717272"
                />
                <path
                    id="Path_242"
                    data-name="Path 242"
                    d="M252.16,204.5a.18.18,0,0,1-.12-.05c-.14-.1-.27-.21-.4-.32a.2.2,0,0,1,.28-.28l.39.32a.2.2,0,0,1,0,.28.21.21,0,0,1-.15.05Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_243"
                    data-name="Path 243"
                    d="M251,203.48a.24.24,0,0,1-.14,0,10.269,10.269,0,0,1-.71-.77.2.2,0,0,1,.3-.26c.22.26.45.5.69.74a.19.19,0,0,1,0,.28A.2.2,0,0,1,251,203.48Zm-1.34-1.55a.21.21,0,0,1-.16-.08c-.2-.28-.4-.57-.58-.86a.21.21,0,0,1,.06-.28.2.2,0,0,1,.28.07c.18.28.37.56.57.83a.2.2,0,0,1,0,.28.17.17,0,0,1-.15.04Zm-1.08-1.74a.21.21,0,0,1-.18-.11,10.079,10.079,0,0,1-.44-.94.19.19,0,0,1,.1-.26.21.21,0,0,1,.27.11c.13.3.27.61.43.91a.2.2,0,0,1-.09.27Zm-.81-1.88a.2.2,0,0,1-.19-.14c-.11-.32-.21-.66-.29-1a.2.2,0,0,1,.14-.24.21.21,0,0,1,.25.15c.08.32.18.65.28,1a.2.2,0,0,1-.12.26Zm-.5-2a.2.2,0,0,1-.2-.16c-.06-.34-.11-.69-.14-1a.2.2,0,1,1,.4,0,5.731,5.731,0,0,0,.14,1,.21.21,0,0,1-.17.23Zm-.2-2a.2.2,0,0,1-.2-.19v-1.04a.19.19,0,0,1,.21-.19.2.2,0,0,1,.19.21q0,.39,0,.78v.23a.19.19,0,0,1-.19.2Zm.13-2h0a.2.2,0,0,1-.2-.31,8.7,8.7,0,0,1,.18-1,.2.2,0,1,1,.39.08c-.07.33-.13.66-.18,1a.19.19,0,0,1-.17.16Zm.43-2h-.06a.19.19,0,0,1-.13-.25c.09-.33.21-.66.33-1a.2.2,0,1,1,.38.15,9.777,9.777,0,0,0-.33,1,.19.19,0,0,1-.17.03Zm.73-1.92h-.08a.2.2,0,0,1-.1-.27c.15-.31.31-.62.48-.92a.218.218,0,1,1,.41.08c-.17.29-.32.59-.47.89a.19.19,0,0,1-.22.15Zm1-1.77a.15.15,0,0,1-.11,0,.2.2,0,0,1-.06-.28c.2-.28.4-.56.62-.83a.2.2,0,0,1,.31.25q-.32.39-.6.81a.18.18,0,0,1-.12-.02Zm1.28-1.6a.2.2,0,0,1-.14-.06.19.19,0,0,1,0-.28c.24-.25.48-.5.74-.73a.19.19,0,0,1,.28,0,.21.21,0,0,1,0,.29c-.25.22-.49.46-.72.7a.17.17,0,0,1-.12.06Zm1.51-1.38a.21.21,0,0,1-.16-.08.2.2,0,0,1,0-.28c.28-.22.56-.42.85-.61a.2.2,0,1,1,.22.33c-.28.19-.55.39-.82.59a.21.21,0,0,1-.05-.02Zm1.7-1.14a.19.19,0,0,1-.17-.1.21.21,0,0,1,.07-.28c.31-.17.62-.33.93-.47a.2.2,0,1,1,.17.36c-.3.14-.61.3-.9.46a.17.17,0,0,1-.06-.04Zm1.86-.86a.2.2,0,0,1-.07-.39c.32-.12.66-.23,1-.33a.2.2,0,0,1,.25.14.21.21,0,0,1-.14.25c-.32.09-.65.2-1,.31Zm2-.57a.2.2,0,1,1,0-.4c.34-.07.68-.13,1-.17a.21.21,0,0,1,.23.17.22.22,0,0,1-.18.23,5.937,5.937,0,0,0-1,.16Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_244"
                    data-name="Path 244"
                    d="M259.76,180.74a.2.2,0,1,1-.01-.4h.51a.2.2,0,0,1,.2.2.22.22,0,0,1-.2.21h-.5Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_245"
                    data-name="Path 245"
                    d="M269.87,184.67a.2.2,0,0,1-.15-.06l-.35-.35a.2.2,0,0,1,.27-.29c.13.12.25.23.37.36a.19.19,0,0,1,0,.28.2.2,0,0,1-.14.06Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_246"
                    data-name="Path 246"
                    d="M261.45,207.31a.2.2,0,0,1-.2-.18.21.21,0,0,1,.19-.22,6.946,6.946,0,0,0,1-.11.2.2,0,1,1,.06.4c-.33.05-.67.09-1,.11Zm2-.3a.2.2,0,0,1-.19-.16.19.19,0,0,1,.15-.24l1-.26a.19.19,0,0,1,.25.13.21.21,0,0,1-.13.25q-.5.15-1,.27Zm1.93-.61a.21.21,0,0,1-.19-.13.2.2,0,0,1,.11-.26c.31-.12.61-.26.91-.41a.21.21,0,0,1,.27.09.2.2,0,0,1-.09.27c-.31.15-.62.29-.94.42Zm1.8-.9a.2.2,0,0,1-.1-.37l.17-.1c.23-.14.45-.29.67-.44a.2.2,0,1,1,.23.33,8.175,8.175,0,0,1-.69.45l-.17.11a.22.22,0,0,1-.12.02Zm1.66-1.15a.21.21,0,0,1-.16-.35q.39-.31.75-.66a.2.2,0,1,1,.27.29c-.24.23-.5.46-.76.68a.22.22,0,0,1-.11.04Zm1.46-1.39a.15.15,0,0,1-.13-.05.19.19,0,0,1,0-.28c.22-.25.44-.5.64-.76a.2.2,0,0,1,.28,0,.21.21,0,0,1,0,.28c-.21.27-.43.54-.66.79a.22.22,0,0,1-.14.06Zm1.23-1.59a.23.23,0,0,1-.11,0,.21.21,0,0,1-.06-.28c.19-.28.36-.56.52-.85a.2.2,0,0,1,.27-.08.21.21,0,0,1,.08.28c-.16.29-.34.59-.53.87a.2.2,0,0,1-.18.06Zm1-1.76h-.08a.2.2,0,0,1-.1-.27c.14-.3.26-.6.38-.91a.2.2,0,1,1,.37.14c-.11.32-.25.63-.39.94a.18.18,0,0,1-.21.1Zm.7-1.89h-.05a.2.2,0,0,1-.14-.25c.09-.31.17-.64.24-1a.2.2,0,0,1,.23-.16.21.21,0,0,1,.16.24c-.07.33-.15.67-.25,1a.19.19,0,0,1-.22.17Zm.41-2h0a.19.19,0,0,1-.17-.22q.06-.5.09-1a.2.2,0,0,1,.4,0,5.527,5.527,0,0,1-.09,1,.2.2,0,0,1-.26.25Zm.11-2a.19.19,0,0,1-.2-.19,5.6,5.6,0,0,0-.06-1,.2.2,0,0,1,.4,0c0,.33.05.68.06,1a.2.2,0,0,1-.2.2Zm-.2-2a.2.2,0,0,1-.2-.17,8.406,8.406,0,0,0-.21-1,.2.2,0,0,1,.15-.24.19.19,0,0,1,.24.14c.09.33.16.67.22,1a.2.2,0,0,1-.16.23Zm-.5-2a.21.21,0,0,1-.19-.13c-.11-.31-.23-.63-.35-.93a.19.19,0,0,1,.1-.26.2.2,0,0,1,.27.1,10.532,10.532,0,0,1,.36,1,.19.19,0,0,1-.12.25Zm-.79-1.85a.21.21,0,0,1-.18-.11c-.14-.27-.29-.54-.46-.81v-.05a.2.2,0,0,1,.07-.28.19.19,0,0,1,.27.07h0c.16.27.32.55.47.84a.2.2,0,0,1-.09.27Zm-1.06-1.72a.18.18,0,0,1-.16-.08c-.2-.27-.4-.53-.62-.78a.2.2,0,0,1,.28-.28q.33.39.63.81a.2.2,0,0,1,0,.28Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_247"
                    data-name="Path 247"
                    d="M260.42,207.35h-.49a.21.21,0,0,1,0-.41h.5a.2.2,0,1,1,0,.4Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_248"
                    data-name="Path 248"
                    d="M258.76,203.93a.15.15,0,0,0,.17-.06l1.1-1.61a8.48,8.48,0,0,0,2.73-.33l1.45,1.28a.17.17,0,0,0,.19,0l2-1.15a.17.17,0,0,0,.08-.17l-.36-1.91a8.55,8.55,0,0,0,1.68-2.17l1.94-.12a.17.17,0,0,0,.15-.12l.62-2.25a.15.15,0,0,0-.07-.17l-1.6-1.1a8.4,8.4,0,0,0-.34-2.72l1.29-1.46a.17.17,0,0,0,0-.19l-1.15-2a.16.16,0,0,0-.17-.07l-1.91.35a8.5,8.5,0,0,0-2.16-1.68l-.13-1.94a.16.16,0,0,0-.11-.15l-2.25-.62a.18.18,0,0,0-.18.07l-1.1,1.6a8.759,8.759,0,0,0-2.72.34l-1.46-1.28a.14.14,0,0,0-.18,0l-2,1.15a.16.16,0,0,0-.08.17l.36,1.91a8.54,8.54,0,0,0-1.69,2.16l-1.94.13a.15.15,0,0,0-.14.11l-.62,2.25a.17.17,0,0,0,.06.18l1.61,1.1a8.2,8.2,0,0,0,.34,2.72l-1.29,1.46a.17.17,0,0,0,0,.18l1.15,2a.18.18,0,0,0,.17.08l1.91-.36a8.589,8.589,0,0,0,2.17,1.69l.12,1.94a.15.15,0,0,0,.12.14Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_249"
                    data-name="Path 249"
                    d="M260.35,196a2.27,2.27,0,1,1,1.57-.63,2.24,2.24,0,0,1-1.57.63Zm0-4.14a1.862,1.862,0,1,0,1.3,3.2h0a1.87,1.87,0,0,0-1.3-3.22Z"
                    fill="#717272"
                />
                <path
                    id="Path_250"
                    data-name="Path 250"
                    d="M262,199.27a.2.2,0,0,1-.19-.14s0,0,0-.06a.21.21,0,0,1,.14-.19,5,5,0,0,0,1.06-.46,5.21,5.21,0,0,0,1.12-.84h0a5.48,5.48,0,0,0,1.39-2.39,5.549,5.549,0,0,0,.19-1.45,5.43,5.43,0,1,0-8.1,4.73.22.22,0,0,1,.1.18.2.2,0,0,1-.3.17,5.83,5.83,0,1,1,7.94-8,5.74,5.74,0,0,1,.76,2.87,6,6,0,0,1-.21,1.56,5.76,5.76,0,0,1-2.74,3.52h0l-.25.13h0q-.31.15-.63.27h-.18Z"
                    fill="#717272"
                />
                <path
                    id="Path_251"
                    data-name="Path 251"
                    d="M296.52,162.39c6.56-10,14.45-13.56,25.5-13.41a1.82,1.82,0,0,1,1.66,1.08l.17.38a1.84,1.84,0,0,1-1.52,2.58c-9.15.77-15.71,2-22.81,11.48a1.83,1.83,0,0,1-3-.16h0a1.83,1.83,0,0,1,0-1.95Z"
                    fill="#fff"
                />
                <path
                    id="Path_252"
                    data-name="Path 252"
                    d="M296.1,157.24l-1.42,9.83a.4.4,0,0,0,.53.43l9-3.27a.47.47,0,0,0,.14-.79,20.44,20.44,0,0,1-7.58-6.45.4.4,0,0,0-.67.25Z"
                    fill="#fff"
                />
                <path
                    id="Path_253"
                    data-name="Path 253"
                    d="M238.86,330c-6.67,8.82-14.17,11.68-24.38,10.89a1.72,1.72,0,0,1-1.47-1.1l-.13-.36a1.69,1.69,0,0,1,1.55-2.3c8.51-.17,14.64-.9,21.78-9.27a1.7,1.7,0,0,1,2.8.33h0a1.72,1.72,0,0,1-.15,1.81Z"
                    fill="#fff"
                />
                <path
                    id="Path_254"
                    data-name="Path 254"
                    d="M238.94,334.78l1.89-9a.36.36,0,0,0-.46-.43l-8.5,2.49a.43.43,0,0,0-.17.72,19,19,0,0,1,6.62,6.41.37.37,0,0,0,.62-.19Z"
                    fill="#fff"
                />
                <path
                    id="Path_255"
                    data-name="Path 255"
                    d="M288.28,329.7c.75,11,5.47,17.52,14.45,22.45a1.71,1.71,0,0,0,1.83-.12l.31-.23a1.69,1.69,0,0,0-.05-2.77c-7-4.79-11.76-8.76-13.16-19.67a1.7,1.7,0,0,0-2.53-1.26h0A1.7,1.7,0,0,0,288.28,329.7Z"
                    fill="#fff"
                />
                <path
                    id="Path_256"
                    data-name="Path 256"
                    d="M285.59,333.67l3.34-8.58a.37.37,0,0,1,.62-.11l5.75,6.73a.43.43,0,0,1-.24.7,19,19,0,0,0-9.05,1.75.37.37,0,0,1-.42-.49Z"
                    fill="#fff"
                />
                <path
                    id="Path_257"
                    data-name="Path 257"
                    d="M312,312.94c-.36,12.95-1.54,57.64-1,73.48a3.41,3.41,0,0,0,3.48,3.08c9.37.27,43.73,1,59.06.39,3.19-.12,5.73-2.41,5.8-5.24.32-13.6,1-51.85-.65-69.37a4.67,4.67,0,0,0-4.43-4c-10.21-.9-44.71-3.11-58-2.35A4.36,4.36,0,0,0,312,312.94Z"
                    fill="#717272"
                />
                <path
                    id="Path_258"
                    data-name="Path 258"
                    d="M316.22,316c-.5,3-2.09,13.11-1.59,16.83.08.55,1.75,1,3.87,1,8.74.13,38.54.42,51.35.16,2.31,0,4.12-.53,4.24-1.12.65-3.09,2.52-12.47,2-16.16-.08-.58-1.85-1.06-4.14-1.12-9.45-.21-41.11-.73-52-.58C317.94,315,316.31,315.43,316.22,316Z"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_259"
                    data-name="Path 259"
                    d="M372.14,318.59a2.5,2.5,0,0,0-1.76-.77L321.29,317a2.51,2.51,0,0,0-2.54,2.28l-1,10.89c-.09.89,1.38,1.64,3.25,1.66l48.26.59c1.87,0,3.41-.69,3.43-1.58l.18-10.5a2.49,2.49,0,0,0-.73-1.75Z"
                    fill="#717272"
                />
                <rect
                    id="Rectangle_14"
                    data-name="Rectangle 14"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(316.61 341.09)"
                    fill="#f3f4f5"
                />
                <rect
                    id="Rectangle_15"
                    data-name="Rectangle 15"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(332.76 341.09)"
                    fill="#f3f4f5"
                />
                <rect
                    id="Rectangle_16"
                    data-name="Rectangle 16"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(347.78 341.09)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_260"
                    data-name="Path 260"
                    d="M374.42,345.09a3.56,3.56,0,0,1-3.57,3.56h-4.13a3.56,3.56,0,0,1-3.56-3.56h0a3.57,3.57,0,0,1,3.56-3.57h4.13a3.57,3.57,0,0,1,3.57,3.57Z"
                    fill="#f3f4f5"
                    opacity="0.5"
                />
                <rect
                    id="Rectangle_17"
                    data-name="Rectangle 17"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(316.61 351.92)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_18"
                    data-name="Rectangle 18"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(332.76 351.92)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_19"
                    data-name="Rectangle 19"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(347.78 351.92)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_20"
                    data-name="Rectangle 20"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(363.93 351.92)"
                    fill="#f3f4f5"
                />
                <rect
                    id="Rectangle_21"
                    data-name="Rectangle 21"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(316.61 362.38)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_22"
                    data-name="Rectangle 22"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(332.76 362.38)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_23"
                    data-name="Rectangle 23"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(347.78 362.38)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_24"
                    data-name="Rectangle 24"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(316.61 373.02)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_25"
                    data-name="Rectangle 25"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(332.76 373.02)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_26"
                    data-name="Rectangle 26"
                    width="11.4"
                    height="7.03"
                    rx="3.44"
                    transform="translate(347.78 373.02)"
                    fill="#f3f4f5"
                    opacity="0.63"
                />
                <rect
                    id="Rectangle_27"
                    data-name="Rectangle 27"
                    width="8.93"
                    height="17.29"
                    rx="4.44"
                    transform="translate(364.5 362.76)"
                    fill="#f3f4f5"
                />
                <circle
                    id="Ellipse_7"
                    data-name="Ellipse 7"
                    cx="10.78"
                    cy="10.78"
                    r="10.78"
                    transform="matrix(0.46, -0.888, 0.888, 0.46, 352.83, 289.548)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_261"
                    data-name="Path 261"
                    d="M358.48,280.68h-.09a.2.2,0,0,1-.09-.27A10.21,10.21,0,0,1,369.2,275a.21.21,0,0,1,.16.24.2.2,0,0,1-.23.16,9.37,9.37,0,0,0-1.76-.16,9.71,9.71,0,0,0-8.71,5.36A.19.19,0,0,1,358.48,280.68Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_8"
                    data-name="Ellipse 8"
                    cx="9.12"
                    cy="9.12"
                    r="9.12"
                    transform="translate(356.87 292.346) rotate(-78.87)"
                    fill="#717272"
                />
                <path
                    id="Path_262"
                    data-name="Path 262"
                    d="M366.71,292v-1a8,8,0,0,1-2.78-.6.57.57,0,0,1-.32-.68l.25-.92a.58.58,0,0,1,.79-.38,6.75,6.75,0,0,0,2.57.54c1,0,1.74-.34,1.74-1s-.58-1-2-1.37c-2-.54-3.4-1.4-3.4-3.14,0-1.57,1.15-2.77,3.15-3.09v-1a.57.57,0,0,1,.57-.58h.59a.58.58,0,0,1,.58.58v.89a7.249,7.249,0,0,1,2.2.39.57.57,0,0,1,.36.7l-.23.85a.58.58,0,0,1-.76.39,6.1,6.1,0,0,0-2.17-.39c-1.18,0-1.52.49-1.52.93s.71.91,2.25,1.38c2.2.66,3.11,1.57,3.11,3.21s-1.12,2.86-3.28,3.2V292a.57.57,0,0,1-.58.57h-.58a.57.57,0,0,1-.54-.57Z"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_9"
                    data-name="Ellipse 9"
                    cx="7.9"
                    cy="7.9"
                    r="7.9"
                    transform="translate(373.6 296.12)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_263"
                    data-name="Path 263"
                    d="M375,300.94a.15.15,0,0,1-.09,0,.2.2,0,0,1-.09-.27,7.47,7.47,0,0,1,6.69-4.12,7.727,7.727,0,0,1,1.36.12.2.2,0,1,1-.08.4,6.852,6.852,0,0,0-1.28-.12,7.07,7.07,0,0,0-6.33,3.9A.2.2,0,0,1,375,300.94Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_10"
                    data-name="Ellipse 10"
                    cx="6.68"
                    cy="6.68"
                    r="6.68"
                    transform="translate(374.028 309.725) rotate(-80.83)"
                    fill="#717272"
                />
                <path
                    id="Path_264"
                    data-name="Path 264"
                    d="M381,309.16v-.72a5.74,5.74,0,0,1-2-.45.4.4,0,0,1-.23-.49l.18-.68a.43.43,0,0,1,.58-.28,5,5,0,0,0,1.88.4c.73,0,1.28-.25,1.28-.76s-.42-.73-1.44-1c-1.45-.39-2.49-1-2.49-2.3s.84-2,2.31-2.26v-.73a.42.42,0,0,1,.42-.43h.43a.42.42,0,0,1,.42.43v.65a5.61,5.61,0,0,1,1.62.29.43.43,0,0,1,.26.51L384,302a.42.42,0,0,1-.56.28,4.4,4.4,0,0,0-1.58-.29c-.87,0-1.12.36-1.12.69s.52.66,1.65,1c1.61.48,2.28,1.15,2.28,2.35a2.49,2.49,0,0,1-2.4,2.34v.81a.43.43,0,0,1-.43.43h-.43a.42.42,0,0,1-.41-.45Z"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_11"
                    data-name="Ellipse 11"
                    cx="7.9"
                    cy="7.9"
                    r="7.9"
                    transform="translate(333.368 287.027) rotate(-80.78)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_265"
                    data-name="Path 265"
                    d="M335.91,277.4h-.09a.2.2,0,0,1-.09-.27,7.51,7.51,0,0,1,8-4,.2.2,0,1,1-.07.4,6.849,6.849,0,0,0-1.28-.12,7.06,7.06,0,0,0-6.33,3.9A.21.21,0,0,1,335.91,277.4Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_12"
                    data-name="Ellipse 12"
                    cx="6.68"
                    cy="6.68"
                    r="6.68"
                    transform="translate(334.289 285.146) rotate(-73.15)"
                    fill="#717272"
                />
                <path
                    id="Path_266"
                    data-name="Path 266"
                    d="M341.94,285.62v-.72a6,6,0,0,1-2-.45.4.4,0,0,1-.23-.49l.18-.68a.43.43,0,0,1,.58-.28,4.91,4.91,0,0,0,1.88.4c.73,0,1.27-.25,1.27-.76s-.42-.73-1.43-1c-1.45-.4-2.49-1-2.49-2.3s.84-2,2.3-2.27v-.72a.43.43,0,0,1,.43-.43h.42a.43.43,0,0,1,.43.43V277a5.611,5.611,0,0,1,1.62.29.43.43,0,0,1,.26.51l-.17.62a.42.42,0,0,1-.56.29,4.42,4.42,0,0,0-1.59-.29c-.86,0-1.11.36-1.11.68s.52.67,1.65,1c1.61.48,2.27,1.15,2.27,2.35s-.81,2.09-2.4,2.34v.81a.42.42,0,0,1-.42.43h-.43a.42.42,0,0,1-.46-.41Z"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_13"
                    data-name="Ellipse 13"
                    cx="5.97"
                    cy="5.97"
                    r="5.97"
                    transform="translate(381.1 267.93)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_267"
                    data-name="Path 267"
                    d="M382.15,271.62h-.09a.2.2,0,0,1-.09-.27,5.68,5.68,0,0,1,5.1-3.14,6,6,0,0,1,1,.09.2.2,0,0,1-.08.4,5,5,0,0,0-.95-.09,5.28,5.28,0,0,0-4.74,2.92A.21.21,0,0,1,382.15,271.62Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_14"
                    data-name="Ellipse 14"
                    cx="5.05"
                    cy="5.05"
                    r="5.05"
                    transform="translate(380.956 277.503) rotate(-74.42)"
                    fill="#717272"
                />
                <path
                    id="Path_268"
                    data-name="Path 268"
                    d="M386.7,277.78v-.55a4.55,4.55,0,0,1-1.54-.33.34.34,0,0,1-.18-.38l.14-.51a.33.33,0,0,1,.44-.21,3.659,3.659,0,0,0,1.42.3c.55,0,1-.19,1-.57s-.31-.55-1.08-.76c-1.09-.3-1.88-.77-1.88-1.74s.64-1.53,1.74-1.71v-.55a.32.32,0,0,1,.32-.32h.32a.32.32,0,0,1,.32.32v.5a3.921,3.921,0,0,1,1.22.22.3.3,0,0,1,.2.38l-.12.47a.32.32,0,0,1-.43.22,3.23,3.23,0,0,0-1.19-.22c-.66,0-.85.27-.85.52s.4.5,1.25.76c1.21.37,1.72.87,1.72,1.78s-.62,1.58-1.82,1.77v.61a.32.32,0,0,1-.32.32H387a.32.32,0,0,1-.3-.32Z"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_15"
                    data-name="Ellipse 15"
                    cx="10.21"
                    cy="10.21"
                    r="10.21"
                    transform="translate(347.7 296.7)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_269"
                    data-name="Path 269"
                    d="M349.49,302.87a.15.15,0,0,1-.09,0,.21.21,0,0,1-.08-.27,9.58,9.58,0,0,1,8.59-5.29,9.233,9.233,0,0,1,1.74.16.2.2,0,0,1,.16.23.21.21,0,0,1-.24.16,9.23,9.23,0,0,0-9.9,4.92A.19.19,0,0,1,349.49,302.87Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_16"
                    data-name="Ellipse 16"
                    cx="8.64"
                    cy="8.64"
                    r="8.64"
                    transform="translate(349.49 298.5)"
                    fill="#717272"
                />
                <path
                    id="Path_270"
                    data-name="Path 270"
                    d="M357.28,313.56v-.94a7.679,7.679,0,0,1-2.63-.57.55.55,0,0,1-.3-.65l.24-.87a.54.54,0,0,1,.74-.36,6.29,6.29,0,0,0,2.43.51c.95,0,1.65-.32,1.65-1s-.54-.95-1.85-1.3c-1.87-.51-3.22-1.33-3.22-3s1.09-2.63,3-2.93v-.94a.55.55,0,0,1,.54-.55h.56a.55.55,0,0,1,.54.55v.84a7.17,7.17,0,0,1,2.09.38.54.54,0,0,1,.34.66l-.22.81a.55.55,0,0,1-.72.37,5.49,5.49,0,0,0-2.05-.38c-1.12,0-1.44.47-1.44.88s.68.87,2.13,1.31c2.08.63,2.94,1.49,2.94,3s-1,2.71-3.1,3v1.06a.54.54,0,0,1-.55.54h-.55A.55.55,0,0,1,357.28,313.56Z"
                    fill="#fff"
                />
                <path
                    id="Path_271"
                    data-name="Path 271"
                    d="M368.31,313.34c-.07.22.71.54,1.16-.33a8.09,8.09,0,0,0,0-2.55,32.931,32.931,0,0,0-3.91-4.09.62.62,0,0,0-.08.85l1.26,1.31A6.092,6.092,0,0,0,366,310a1.71,1.71,0,0,0,.17,1.29c.22.4.52.91.8,1.32a1.73,1.73,0,0,0,1.34.73Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_272"
                    data-name="Path 272"
                    d="M367.3,309.37l1.15,1,.35,1-1,1.13a13.482,13.482,0,0,0-.6-2.32C366.94,309.69,367.07,309.49,367.3,309.37Z"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_273"
                    data-name="Path 273"
                    d="M390.72,384.6s.29,1.63.43,3.24a1.11,1.11,0,0,1-1.06,1.21c-2.15.09-6.76.26-8.41.19a.37.37,0,0,1-.32-.5h0a.8.8,0,0,1,.42-.43l7.6-3.5Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_274"
                    data-name="Path 274"
                    d="M391,383.64l-.23,1.95a2.42,2.42,0,0,1-2.24-.08l.55-2.17Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_275"
                    data-name="Path 275"
                    d="M390.79,346.93c.1.51.53,25.44-2.13,36.62a.38.38,0,0,0,.22.44,6.48,6.48,0,0,0,2.17.44.65.65,0,0,0,.65-.47c.76-2.59,4.41-15.58,4.89-28,.53-13.86,0-.47,0-.47l-.31-8.57Z"
                    fill="#636363"
                />
                <path
                    id="Path_276"
                    data-name="Path 276"
                    d="M399.47,385.45a11.549,11.549,0,0,1,.9,3,.68.68,0,0,1-.59.82c-.71.07-1.81.16-2.68.15a.68.68,0,0,1-.67-.76,5.59,5.59,0,0,1,1.33-3.13Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_277"
                    data-name="Path 277"
                    d="M399.87,382.94l-.54,2.95a1.89,1.89,0,0,1-1.59.11l.26-3.18Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_278"
                    data-name="Path 278"
                    d="M401.34,347.7c2.18,13.15-.48,32.51-1.37,36.3a.6.6,0,0,1-.48.45,4,4,0,0,1-1.7-.07.53.53,0,0,1-.39-.5c-.12-3.06.09-21.87-1.94-29.3a1.66,1.66,0,0,0-.65-.93l-3.94-2.8-.3-4.53Z"
                    fill="#636363"
                />
                <path
                    id="Path_279"
                    data-name="Path 279"
                    d="M387.45,322.77a61.449,61.449,0,0,1,13.74,1.71c1.94,11.37.34,24.47.34,24.47-5.06,1.33-10.77-.81-10.77-.81C389.92,343.39,386,330,386,330a21.49,21.49,0,0,1-8-2.54,13.87,13.87,0,0,0,2.76-5.79,22,22,0,0,0,6.69,1.1Z"
                    fill="#717272"
                />
                <path
                    id="Path_280"
                    data-name="Path 280"
                    d="M368.15,313.15a1.24,1.24,0,0,1,1.45-.41c1,4.06,6,7.35,11.18,9a13.87,13.87,0,0,1-2.76,5.79C369.42,322.66,368.15,313.15,368.15,313.15Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_281"
                    data-name="Path 281"
                    d="M398.68,330.81l2.51-6.33s6.1,4.15,7.1,9.41a14.25,14.25,0,0,0-5.3,1.42C402.54,332.83,398.68,330.81,398.68,330.81Z"
                    fill="#717272"
                />
                <path
                    id="Path_282"
                    data-name="Path 282"
                    d="M394.06,317.47l2.08,6a.21.21,0,0,1-.1.26,4.89,4.89,0,0,1-5.07-.34,1,1,0,0,1-.46-.73l-.68-5.2Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_283"
                    data-name="Path 283"
                    d="M389.54,311.9s-2.28,4.3-2,6,3.12,1.61,5.59.2l1.73-4.64Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_284"
                    data-name="Path 284"
                    d="M393,315.85a.17.17,0,0,1-.07-.25,4.72,4.72,0,0,0,.63-1.35s.41-.27-1-.61-3.63-.89-4.08-2.13.72-4.24,2.58-1.82a.18.18,0,0,0,.28,0,1.83,1.83,0,0,1,2.23-.73,1.67,1.67,0,0,1,1.14,1.62.18.18,0,0,0,.21.18,2.05,2.05,0,0,1,2.39,1.12,1.65,1.65,0,0,1-.12,2,.18.18,0,0,0,.08.29,1.06,1.06,0,0,1,.74,1.21c-.06,1.13-1.31,1-1.67,1a.18.18,0,0,0-.16.05,6,6,0,0,1-3.18,1.95.18.18,0,0,1-.19-.23l.65-1.88a.17.17,0,0,0-.1-.22Z"
                    fill="#717272"
                />
                <path
                    id="Path_285"
                    data-name="Path 285"
                    d="M392.77,316.12s1.63-1.11,1.75-.17-1.47,1.36-2.25,1Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_286"
                    data-name="Path 286"
                    d="M403,335.31s2.13,9.62.2,15l1.93.89s4.68-13.69,3.17-17.34C405.31,333.57,403.83,334.37,403,335.31Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_287"
                    data-name="Path 287"
                    d="M403.19,350.34s-1.22,1.58-1.12,2.21.12.88.12.88.61-.42.57-.95c-.08,1.7-.65,3.63-.14,3.54s3.2-2.56,2.6-5.2C403.84,349.87,403.46,350,403.19,350.34Z"
                    fill="#e3e2e2"
                />
                <circle
                    id="Ellipse_17"
                    data-name="Ellipse 17"
                    cx="10.34"
                    cy="10.34"
                    r="10.34"
                    transform="translate(363.27 69.59)"
                    fill="#fff"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_18"
                    data-name="Ellipse 18"
                    cx="10.34"
                    cy="10.34"
                    r="10.34"
                    transform="translate(483.66 309.37)"
                    fill="#fff"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_19"
                    data-name="Ellipse 19"
                    cx="7.79"
                    cy="7.79"
                    r="7.79"
                    transform="translate(45.37 144.94)"
                    fill="#fff"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_20"
                    data-name="Ellipse 20"
                    cx="6.73"
                    cy="6.73"
                    r="6.73"
                    transform="translate(474.24 253.62)"
                    fill="#fff"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_288"
                    data-name="Path 288"
                    d="M28.25,282.43H21.87v-6.38a.79.79,0,0,0-.8-.79h0a.81.81,0,0,0-.81.79v6.38H13.89a.8.8,0,1,0,0,1.6h6.37v6.39a.81.81,0,0,0,.81.79.79.79,0,0,0,.8-.79h0V284h6.38a.79.79,0,0,0,.8-.79A.8.8,0,0,0,28.25,282.43Z"
                    fill="#e1e1e1"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_289"
                    data-name="Path 289"
                    d="M268.65,108.45h-5.59v-5.58a.69.69,0,0,0-.7-.69h0a.71.71,0,0,0-.71.69v5.58h-5.57a.72.72,0,0,0-.71.71.71.71,0,0,0,.71.7h5.57v5.59a.71.71,0,0,0,.71.69.69.69,0,0,0,.7-.69h0v-5.59h5.59a.7.7,0,0,0,.7-.7.71.71,0,0,0-.7-.71Z"
                    fill="#e1e1e1"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_290"
                    data-name="Path 290"
                    d="M206.48,82.11h-7.16V75a.88.88,0,0,0-.89-.89h0a.91.91,0,0,0-.91.89v7.14h-7.14a.92.92,0,0,0-.9.91.9.9,0,0,0,.9.89h7.14V91.1a.91.91,0,0,0,.91.89.89.89,0,0,0,.89-.89h0V83.91h7.16a.89.89,0,0,0,.9-.89.92.92,0,0,0-.9-.91Z"
                    fill="#e1e1e1"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
            </g>
        </SVGIcon>
    );
}
